import cnContent from "./token/ar-ae/cn.js";
import usContent from "./token/ar-ae/us.js";
import jpContent from "./token/ar-ae/jp.js";
import koContent from "./token/ar-ae/ko.js";
import geContent from "./token/ar-ae/ge.js";
import ukContent from "./token/ar-ae/uk.js";
import uaeContent from "./token/ar-ae/uae.js";
import frContent from "./token/ar-ae/fr.js";
import sgContent from "./token/ar-ae/sg.js";

import agreementContent from "./agreement/ar-ae.js";

export default {
  // ===== 在线客服（chat） =====
  "chat.title": "الدعم الفني المباشر",
  "chat.connected": "متصل",
  "chat.connecting": "جارٍ الاتصال…",
  "chat.empty": "لا توجد رسائل بعد، لا تتردد في بدء المحادثة",
  "chat.placeholder": "اكتب رسالتك…",
  "chat.send": "إرسال",
  "chat.sending": "جارٍ الإرسال",
  "chat.sent": "تم الإرسال",
  "chat.read": "مقروء",
  "chat.sendFailed": "فشل الإرسال، يرجى المحاولة مرة أخرى",
  "chat.sessionFailed": "فشل تحميل المحادثة، يرجى المحاولة مرة أخرى",
  "chat.image": "إرسال صورة",
  "chat.imageTooLarge": "يجب أن تكون الصورة أقل من 5 ميجابايت",
  "chat.uploading": "جارٍ الرفع…",
  "chat.uploadFailed": "فشل الرفع",
  "chat.kicked": "انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى",
  "chat.recall": "سحب",
  "chat.recallConfirm": "سحب هذه الرسالة؟",
  "chat.recallFailed": "فشل السحب، يرجى المحاولة مرة أخرى",
  "chat.recalledSelf": "قمت بسحب رسالة",
  "chat.recalledPeer": "قام الطرف الآخر بسحب رسالة",
  "chat.typingPeer": "الدعم يكتب الآن…",
  "chat.confirm": "تأكيد",
  "chat.cancel": "إلغاء",
  "head.index": "الرئيسية",
  "head.product": "المنتجات",
  "head.computeProduct": "منتجات قوة الحوسبة",
  "head.computeProductDesc": "اشترِ قوة الحوسبة واحصل على عوائد عالمية",
  "head.rentalProduct": "منتجات الإيجار",
  "head.rentalProductDesc": "استأجر خوادم عالية الأداء، عوائد مستقرة",
  "head.rental": "الإيجار",
  "head.about": "من نحن",

  // ===== قائمة المستخدم المنسدلة =====
  "menu.profile": "الملف الشخصي",
  "menu.security": "أمان الحساب",
  "menu.settings": "الإعدادات",
  "menu.products": "قائمة المنتجات",
  "menu.deposits": "سجل الإيداع",
  "menu.withdraws": "سجل السحب",
  "menu.walletLog": "سجل المعاملات",
  "menu.logout": "تسجيل الخروج",
  "menu.logoutSuccess": "تم تسجيل الخروج بنجاح",

  // ===== رسائل الموقع =====
  "notice.title": "الرسائل",
  "notice.empty": "لا توجد رسائل",
  "notice.loading": "جار التحميل...",
  "notice.loadMore": "تحميل المزيد",
  "notice.noMore": "لا مزيد من الرسائل",
  "notice.unread": "غير مقروءة",
  "notice.detail": "تفاصيل الرسالة",
  "notice.close": "إغلاق",


  // ===== التذييل =====
  "footer.contactEmail": "البريد الإلكتروني للتواصل",

  // ===== الصفحة الرئيسية =====
  "home.heroTitle1": "سيد قوة الحوسبة العالمي الجديد",
  "home.heroTitle2": "محرك ثروة مزدوج الدفع",
  "home.heroDesc":
    "المنصة تختار أولاً المواقع الناضجة التي تم حجزها مسبقًا للإيجار من قبل عمالقة النماذج الكبيرة مثل Microsoft وOpenAI وDeepSeek",
  "home.heroBtn": "احصل على عوائد قوة الحوسبة الآن ←",
  "home.statTrade": "حجم التداول اليومي",
  "home.statTradeValue": "+1 مليار",
  "home.statReliability": "الموثوقية",
  "home.statGlobal": "خدمة عالمية",
  "home.buildTitle1": "ابنِ",
  "home.buildTitle2": "مركز قوة الحوسبة الخاص بك",
  "home.buildDesc1":
    "إدارة مستقلة · إيجار مستقل · عوائد شفافة — نحن فقط ندير التشغيل،",
  "home.buildDesc2": "جميع العوائد تعود للباني",
  "home.buildFeature1Title": "إدارة مستقلة",
  "home.buildFeature1Desc":
    "لديك سيطرة كاملة على مركز البيانات، وتقرر استراتيجية الإيجار والتسعير بنفسك",
  "home.buildFeature2Title": "عوائد شفافة",
  "home.buildFeature2Desc":
    "تصور البيانات المالية في الوقت الفعلي، كل عائد واضح وقابل للتحقق",
  "home.buildFeature3Title": "تشغيل احترافي",
  "home.buildFeature3Desc":
    "نحن مسؤولون عن صيانة الأجهزة وضمان الشبكة والدعم الفني 7×24 ساعة",
  "home.buildFeature4Title": "جميع العوائد لك",
  "home.buildFeature4Desc":
    "بعد خصم تكاليف التشغيل الأساسية، تعود جميع عوائد الإيجار للباني",
  "home.buildBtn": "ابدأ البناء الآن ←",
  "home.buildStatsTitle": "📈 نظرة عامة على عوائد البناء",
  "home.buildStatsUpdate": "تحديث فوري",
  "home.buildStatRooms": "مراكز البيانات المبنية",
  "home.buildStatServers": "الخوادم قيد التشغيل",
  "home.buildStatProfit": "إجمالي عوائد البنائين",
  "home.buildStatPayback": "متوسط فترة استرداد رأس المال",
  "home.buildStatMonth": "شهر",
  "home.buildCta": "🎯 انضم الآن، ابدأ مشروع البنية التحتية لقوة الحوسبة",
  "home.buildCtaBtn": "اعرف المزيد",
  "home.featuresBadge": "✦ المزايا الأساسية",
  "home.featuresTitle1": "لماذا تختار",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "كفاءة وسهولة",
  "home.feature1Desc":
    "تستفيد AETRIVOL من مزاياها لتمكين الأفراد من الاستفادة من أرباح عصر قوة الحوسبة",
  "home.feature2Title": "أمان على المستوى الوطني",
  "home.feature2Desc":
    "حماية شبكة متعددة الطبقات، تشفير البيانات، مراقبة أمنية 7×24 ساعة",
  "home.feature3Title": "أجهزة عالية الأداء",
  "home.feature3Desc":
    "أحدث وحدات معالجة الرسوميات NVIDIA، مع تخزين NVMe عالي السرعة وذاكرة DDR5",
  "home.feature4Title": "عقد عالمية",
  "home.feature4Desc":
    "تغطية مراكز بيانات آسيا والمحيط الهادئ وأوروبا وأمريكا الشمالية، تسريع عالمي بزمن استجابة منخفض",
  "home.appBadge": "📱 الجوال",
  "home.appTitle": "AETRIVOL APP",
  "home.appDesc2":
    "لتمكنك من متابعة ديناميكيات سوق قوة الحوسبة في أي وقت ومكان،",
  "home.appDesc3": "وإدارة قوة حوسبة GPU الخاصة بك بنقرة واحدة.",
  "home.appQrText": "امسح الرمز لتنزيل التطبيق",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "شركاء",
  "home.walletsTitle2": "التعاون",
  "home.walletsDesc": "اربط محفظتك الموثوقة، وأدر أصولك بأمان",
  "home.settleTitle1": "تسوية",
  "home.settleTitle2": "فورية",
  "home.settleDesc": "عرض تسوية العوائد الفورية للمستخدمين العالميين",
  "home.modalTitle": "قريبًا",
  "home.modalDesc1": "لا توجد حاليًا مشاريع بناء مراكز بيانات جديدة",
  "home.modalDesc2": "شكرًا لاهتمامكم ودعمكم!",
  "home.modalBtn": "فهمت",
  "home.altQr": "امسح الرمز للتنزيل",
  "home.altApp": "لقطة شاشة التطبيق",
  "home.altWallet": "أيقونة المحفظة",

  // ===== الصفحة الرئيسية - دول قوة الحوسبة =====
  "tokenList.title1": "اختر",
  "tokenList.title2": "دولة قوة الحوسبة",
  "tokenList.desc":
    "دول قوة الحوسبة الرائدة عالميًا، استثمار منخفض وعوائد عالية",
  "tokenList.buy": "اشترِ الآن",
  "tokenList.more": "المزيد من المنتجات",
  "tokenList.tagHot": "🔥 رائج",
  "tokenList.tagProfit": "💰 عوائد عالية",
  "tokenList.tagRecommend": "⭐ موصى به",
  "tokenList.tagNew": "🆕 جديد",

  // ===== الصفحة الرئيسية - إيجار الخوادم =====
  "serverList.title1": "إيجار",
  "serverList.title2": "الخوادم",
  "serverList.desc":
    "خوادم ناضجة عالية الأداء، تساعدك على تحقيق عوائد إيجار فائقة",
  "serverList.dailyIncome": "الدخل اليومي",
  "serverList.value": "قيمة الخادم",
  "serverList.yield": "معدل العائد",
  "serverList.gpu": "GPU",
  "serverList.vram": "الذاكرة",
  "serverList.storage": "التخزين",
  "serverList.status": "الحالة",
  "serverList.available": "✅ متاح للإيجار",
  "serverList.full": "⏳ ممتلئ",
  "serverList.countdown": "حتى البدء",
  "serverList.days": "يوم",
  "serverList.over": "ينتهي خلال",
  "serverList.yunxz": "قيد التشغيل",
  "serverList.yunxzjs": "ينتهي خلال",
  "serverList.btnFull": "ممتلئ",
  "serverList.btnRent": "استأجر الآن ←",
  "serverList.btnWait": "بانتظار البدء",
  "serverList.look": "عرض التفاصيل",
  "serverList.btnEnded": "انتهى",
  "serverList.more": "عرض المزيد من المنتجات",
  "serverList.spec1": "الإصدار الأساسي",
  "serverList.spec2": "الإصدار الخفيف",
  "serverList.spec3": "إصدار الأداء",
  "serverList.spec4": "الإصدار الرائد",
  "serverList.tagHot": "🔥 رائج",
  "serverList.tagRecommend": "⭐ موصى به",
  "serverList.tagNew": "🌟 جديد",

  // ===== الصفحة الرئيسية - شريط التسوية =====
  "settle.amount": "مبلغ التسوية",
  "settle.status": "تمت التسوية",
  "settle.power": "قيمة الحوسبة",
  "settle.rental": "إيجار الخادم",
  "settle.basic": "العائد الأساسي",
  "settle.cycle": "العائد الدوري",
  "settle.phase1": "المرحلة الأولى",
  "settle.phase2": "المرحلة الثانية",
  "settle.phase3": "المرحلة الثالثة",
  "settle.phase4": "المرحلة الرابعة",

  // ===== مركز الأعضاء =====
  "member.recharge": "إيداع",
  "member.withdraw": "سحب",
  "member.tabProducts": "منتجاتي",
  "member.tabHistory": "السجل",
  "member.tabWalletLog": "سجل المحفظة",
  "member.tabDeposits": "سجل الإيداع",
  "member.tabWithdraws": "سجل السحب",
  "member.tabAddresses": "عناوين السحب",
  "member.avatarAlt": "صورة المستخدم",
  "member.settingsTitle": "الإعدادات",
  "member.logoutTitle": "تسجيل الخروج",
  "member.tabTokenProduct": "منتجات قوة الحوسبة",
  "member.tabRentProduct": "منتجات الإيجار",

  // ===== صفحة الإعدادات =====
  "setting.back": "رجوع",
  "setting.title": "⚙️ الإعدادات",
  "setting.menuProfile": "المعلومات الشخصية",
  "setting.menuSecurity": "أمان الحساب",
  "setting.menuVerify": "التحقق من الحساب",
  "setting.menuChangePwd": "تغيير كلمة المرور",
  "setting.menuTradePwd": "كلمة مرور المعاملات",
  "setting.getUserInfoFail": "فشل الحصول على معلومات المستخدم",

  // ===== صفحة الإعدادات - المعلومات الشخصية =====
  "profile.title": "المعلومات الشخصية",
  "profile.subtitle": "إدارة معلوماتك الأساسية",
  "profile.avatar": "الصورة الرمزية",
  "profile.avatarAlt": "الصورة الرمزية",
  "profile.changeAvatar": "تغيير الصورة الرمزية",
  "profile.systemAvatar": "الصور الرمزية للنظام",
  "profile.firstName": "الاسم الكامل",
  "profile.firstNamePlaceholder": "أدخل اسمك الكامل",
  "profile.lastName": "اسم العائلة",
  "profile.lastNamePlaceholder": "أدخل اسم العائلة",
  "profile.phone": "الهاتف",
  "profile.phonePlaceholder": "أدخل رقم الهاتف",
  "profile.address": "العنوان",
  "profile.addressPlaceholder": "أدخل العنوان",
  "profile.authUnverified": "غير موثّق",
  "profile.gender": "الجنس",
  "profile.birthday": "تاريخ الميلاد",
  "profile.birthdayPlaceholder": "اختر تاريخ الميلاد",
  "profile.country": "البلد",
  "profile.countryPlaceholder": "اختر الدولة",
  "profile.saving": "جارٍ الحفظ...",
  "profile.saveInfo": "حفظ المعلومات",
  "profile.selectSystemAvatar": "اختر صورة رمزية للنظام",
  "profile.avatarAltNum": "الصورة الرمزية {count}",
  "profile.selectImageFile": "يرجى اختيار ملف صورة",
  "profile.imageTooLarge": "حجم الصورة لا يمكن أن يتجاوز 5 ميجابايت",
  "profile.uploadFail": "فشل الرفع",
  "profile.updateFail": "فشل التحديث",
  "profile.updateSuccess": "تم التحديث بنجاح",
  "profile.uploadFailNoPath": "فشل الرفع، لم يتم الحصول على عنوان الصورة",
  "profile.uploadFailRetry": "فشل الرفع، يرجى المحاولة لاحقًا",
  "profile.saveFail": "فشل الحفظ",
  "profile.saveSuccess": "تم الحفظ بنجاح",
  "profile.saveFailRetry": "فشل الحفظ، يرجى المحاولة لاحقًا",

  // ===== صفحة الإعدادات - التحقق من الحساب =====
  "verifyPanel.title": "التحقق من الحساب",
  "verifyPanel.subtitle": "رفع صلاحيات الحساب ومستوى الثقة",
  "verifyPanel.realName": "التحقق من الهوية",
  "verifyPanel.realNameDesc": "لقد قمت بتقديم معلومات التحقق من الهوية",
  "verifyPanel.verified": "تم التحقق ✓",
  "verifyPanel.goVerify": "التحقق الآن ←",

  // ===== صفحة الإعدادات - أمان الحساب =====
  "securityPanel.title": "أمان الحساب",
  "securityPanel.subtitle": "حماية أمان حسابك",
  "securityPanel.phoneBind": "ربط الهاتف",
  "securityPanel.phoneBound": "مرتبط {phone}",
  "securityPanel.notBound": "غير مرتبط",
  "securityPanel.emailBind": "ربط البريد الإلكتروني",
  "securityPanel.emailBound": "مرتبط {email}",
  "securityPanel.twofa": "التحقق بخطوتين (2FA)",
  "securityPanel.twofaOn":
    "مفعل · يتطلب إدخال رمز تحقق ديناميكي في كل تسجيل دخول",
  "securityPanel.twofaOff": "غير مفعل · يُنصح بالتفعيل لتعزيز أمان الحساب",
  "securityPanel.twofaEnabled": "مفعل ✓",
  "securityPanel.enableTwofa": "تفعيل التحقق بخطوتين",
  "securityPanel.disableTwofaTitle": "إيقاف التحقق بخطوتين",
  "securityPanel.enableTwofaTitle": "تفعيل التحقق بخطوتين",
  "securityPanel.qrAlt": "رمز QR للتحقق بخطوتين",
  "securityPanel.tip1":
    "1. قم بتنزيل Google Authenticator أو Microsoft Authenticator",
  "securityPanel.tip2": "2. امسح رمز QR أعلاه أو أدخل المفتاح",
  "securityPanel.copy": "نسخ",
  "securityPanel.verifyCode": "رمز التحقق",
  "securityPanel.verifyCodePlaceholder":
    "أدخل رمز التحقق الديناميكي المكون من 6 أرقام",
  "securityPanel.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "securityPanel.emailCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "securityPanel.resend": "إعادة المحاولة بعد {count} ثانية",
  "securityPanel.sendCode": "إرسال رمز التحقق",
  "securityPanel.disableWarning1":
    "بعد إيقاف التحقق بخطوتين، سيفقد حسابك الحماية الأمنية الإضافية.",
  "securityPanel.disableWarning2":
    "يرجى التأكد من رغبتك في إيقاف التحقق بخطوتين.",
  "securityPanel.cancel": "إلغاء",
  "securityPanel.confirmDisable": "تأكيد الإيقاف",
  "securityPanel.confirmEnable": "تأكيد التفعيل",
  "securityPanel.getSecretFail": "فشل الحصول على المفتاح",
  "securityPanel.copySuccess": "تم نسخ المفتاح إلى الحافظة",
  "securityPanel.copyFail": "فشل نسخ المفتاح",
  "securityPanel.enterVerifyCode":
    "أدخل رمز التحقق الديناميكي المكون من 6 أرقام",
  "securityPanel.operationFail": "فشلت العملية",
  "securityPanel.twofaEnabledMsg": "تم تفعيل التحقق بخطوتين!",
  "securityPanel.twofaDisabledMsg": "تم إيقاف التحقق بخطوتين!",
  "securityPanel.enterEmailCode": "أدخل رمز التحقق عبر البريد الإلكتروني",

  // ===== صفحة الإعدادات - تغيير كلمة المرور =====
  "changePwd.title": "تغيير كلمة المرور",
  "changePwd.subtitle": "غيّر كلمة المرور بانتظام لحماية أمان الحساب",
  "changePwd.warning":
    "لم تقم بتفعيل التحقق بخطوتين بعد، لا يمكن تغيير كلمة المرور. يرجى تفعيل التحقق بخطوتين أولاً.",
  "changePwd.goEnable": "تفعيل الآن",
  "changePwd.newPwd": "كلمة المرور الجديدة",
  "changePwd.newPwdPlaceholder": "أدخل كلمة المرور الجديدة (6 أرقام على الأقل)",
  "changePwd.confirmPwd": "تأكيد كلمة المرور الجديدة",
  "changePwd.confirmPwdPlaceholder": "أدخل كلمة المرور الجديدة مرة أخرى",
  "changePwd.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "changePwd.emailCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "changePwd.resend": "إعادة المحاولة بعد {count} ثانية",
  "changePwd.sendCode": "إرسال رمز التحقق",
  "changePwd.confirmBtn": "تأكيد التغيير",
  "changePwd.twofaDesc":
    "أدخل رمز التحقق بخطوتين لإرسال رمز التحقق عبر البريد الإلكتروني",
  "changePwd.pwdTooShort": "كلمة المرور الجديدة يجب أن تكون 6 أرقام على الأقل",
  "changePwd.pwdMismatch": "كلمتا المرور الجديدتان غير متطابقتين",
  "changePwd.enableTwofaFirst":
    "يرجى تفعيل التحقق بخطوتين أولاً قبل تغيير كلمة المرور",
  "changePwd.codeError": "رمز التحقق خاطئ",
  "changePwd.enterEmailCode": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "changePwd.success": "تم تغيير كلمة المرور بنجاح! يرجى تسجيل الدخول مرة أخرى",

  // ===== صفحة الإعدادات - كلمة مرور المعاملات =====
  "tradePwd.title": "كلمة مرور المعاملات",
  "tradePwd.subtitle": "حماية أمان أصولك",
  "tradePwd.warning":
    "لم تقم بتفعيل التحقق بخطوتين بعد، لا يمكن تغيير كلمة مرور المعاملات. يرجى تفعيل التحقق بخطوتين أولاً.",
  "tradePwd.goEnable": "تفعيل الآن",
  "tradePwd.newPwd": "كلمة مرور المعاملات الجديدة",
  "tradePwd.newPwdPlaceholder":
    "أدخل كلمة مرور المعاملات الجديدة (6 أرقام على الأقل)",
  "tradePwd.confirmPwd": "تأكيد كلمة مرور المعاملات",
  "tradePwd.confirmPwdPlaceholder": "أدخل كلمة مرور المعاملات الجديدة مرة أخرى",
  "tradePwd.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "tradePwd.emailCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "tradePwd.resend": "إعادة المحاولة بعد {count} ثانية",
  "tradePwd.sendCode": "إرسال رمز التحقق",
  "tradePwd.confirmBtn": "تأكيد التغيير",
  "tradePwd.twofaDesc":
    "أدخل رمز التحقق بخطوتين لإرسال رمز التحقق عبر البريد الإلكتروني",
  "tradePwd.pwdTooShort":
    "كلمة مرور المعاملات الجديدة يجب أن تكون 6 أرقام على الأقل",
  "tradePwd.pwdMismatch": "كلمتا مرور المعاملات غير متطابقتين",
  "tradePwd.enableTwofaFirst":
    "يرجى تفعيل التحقق بخطوتين أولاً قبل تغيير كلمة مرور المعاملات",
  "tradePwd.codeError": "رمز التحقق خاطئ",
  "tradePwd.enterEmailCode": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "tradePwd.success": "تم تغيير كلمة مرور المعاملات بنجاح!",

  // ===== مركز الأعضاء - السجل =====
  "history.tabToken": "سجل قوة الحوسبة",
  "history.tabRent": "سجل الإيجار",

  // ===== مركز الأعضاء - سجل قوة الحوسبة =====
  "historyToken.type": "النوع",
  "historyToken.allType": "جميع الأنواع",
  "historyToken.buy": "شراء",
  "historyToken.income": "عائد",
  "historyToken.reset": "إعادة تعيين",
  "historyToken.loading": "جارٍ التحميل...",
  "historyToken.empty": "لا توجد منتجات",
  "historyToken.date": "التاريخ",
  "historyToken.product": "المنتج",
  "historyToken.quantity": "الكمية",
  "historyToken.amount": "المبلغ",
  "historyToken.fee": "الرسوم",
  "historyToken.total": "الإجمالي",
  "historyToken.time": "الوقت",
  "historyToken.profit": "الربح/الخسارة",
  "historyToken.deduct": "الخصم",
  "historyToken.profitPositive": "ربح",
  "historyToken.profitNegative": "خسارة",
  "historyToken.unknownStatus": "حالة غير معروفة",
  "historyToken.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "historyToken.firstPage": "الصفحة الأولى",
  "historyToken.prevPage": "السابقة",
  "historyToken.nextPage": "التالية",
  "historyToken.lastPage": "الأخيرة",
  "historyToken.perPage": "{count} سجل/صفحة",

  // ===== مركز الأعضاء - سجل إيجار الخوادم =====
  "historyServer.type": "النوع",
  "historyServer.allType": "جميع الأنواع",
  "historyServer.buy": "شراء",
  "historyServer.income": "عائد",
  "historyServer.reset": "إعادة تعيين",
  "historyServer.loading": "جارٍ التحميل...",
  "historyServer.empty": "لا توجد منتجات",
  "historyServer.date": "التاريخ",
  "historyServer.product": "المنتج",
  "historyServer.share": "الحصة",
  "historyServer.amount": "المبلغ",
  "historyServer.fee": "الرسوم",
  "historyServer.total": "الإجمالي",
  "historyServer.time": "الوقت",
  "historyServer.unknownStatus": "حالة غير معروفة",
  "historyServer.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "historyServer.firstPage": "الصفحة الأولى",
  "historyServer.prevPage": "السابقة",
  "historyServer.nextPage": "التالية",
  "historyServer.lastPage": "الأخيرة",
  "historyServer.perPage": "{count} سجل/صفحة",

  // ===== مركز الأعضاء - سجل الإيداع =====
  "deposit.loading": "جارٍ التحميل...",
  "deposit.empty": "لا توجد سجلات إيداع",
  "deposit.coin": "العملة",
  "deposit.quantity": "الكمية",
  "deposit.network": "الشبكة",
  "deposit.address": "العنوان",
  "deposit.status": "الحالة",
  "deposit.time": "الوقت",
  "deposit.success": "نجاح",
  "deposit.processing": "قيد المعالجة",
  "deposit.paginationInfo": "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "deposit.firstPage": "الصفحة الأولى",
  "deposit.prevPage": "السابقة",
  "deposit.nextPage": "التالية",
  "deposit.lastPage": "الأخيرة",
  "deposit.perPage": "{count} سجل/صفحة",

  // ===== مركز الأعضاء - سجل السحب =====
  "withdrawal.loading": "جارٍ التحميل...",
  "withdrawal.empty": "لا توجد سجلات سحب",
  "withdrawal.coin": "العملة",
  "withdrawal.quantity": "الكمية",
  "withdrawal.network": "الشبكة",
  "withdrawal.address": "العنوان",
  "withdrawal.status": "الحالة",
  "withdrawal.time": "الوقت",
  "withdrawal.statusProcessing": "قيد المعالجة",
  "withdrawal.statusSuccess": "نجاح",
  "withdrawal.statusFailed": "فشل",
  "withdrawal.statusUnknown": "غير معروف",
  "withdrawal.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "withdrawal.firstPage": "الصفحة الأولى",
  "withdrawal.prevPage": "السابقة",
  "withdrawal.nextPage": "التالية",
  "withdrawal.lastPage": "الأخيرة",
  "withdrawal.perPage": "{count} سجل/صفحة",

  // ===== مركز الأعضاء - عناوين السحب =====
  "addresse.title": "عناوين السحب",
  "addresse.addAddress": "+ إضافة عنوان",
  "addresse.loading": "جارٍ التحميل...",
  "addresse.empty": "لا توجد عناوين سحب",
  "addresse.coin": "العملة",
  "addresse.network": "الشبكة",
  "addresse.address": "العنوان",
  "addresse.time": "الوقت",
  "addresse.action": "إجراء",
  "addresse.delete": "حذف",
  "addresse.deleteConfirm":
    "هل أنت متأكد من حذف عنوان السحب هذا؟ لا يمكن التراجع عن هذه العملية.",
  "addresse.cancel": "إلغاء",
  "addresse.confirmDelete": "تأكيد الحذف",
  "addresse.deleteSuccess": "تم الحذف بنجاح",
  "addresse.paginationInfo": "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "addresse.firstPage": "الصفحة الأولى",
  "addresse.prevPage": "السابقة",
  "addresse.nextPage": "التالية",
  "addresse.lastPage": "الأخيرة",
  "addresse.perPage": "{count} سجل/صفحة",

  // ===== مركز الأعضاء - سجل المحفظة =====
  "walletLog.type": "النوع",
  "walletLog.allType": "جميع الأنواع",
  "walletLog.reset": "إعادة تعيين",
  "walletLog.loading": "جارٍ التحميل...",
  "walletLog.empty": "لا توجد منتجات",
  "walletLog.project": "المشروع",
  "walletLog.amount": "المبلغ",
  "walletLog.time": "الوقت",
  "walletLog.day": "يوم",
  "walletLog.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "walletLog.firstPage": "الصفحة الأولى",
  "walletLog.prevPage": "السابقة",
  "walletLog.nextPage": "التالية",
  "walletLog.lastPage": "الأخيرة",
  "walletLog.perPage": "{count} سجل/صفحة",
  "walletLog.typeDeposit": "إيداع",
  "walletLog.typeWithdraw": "سحب",
  "walletLog.typePay": "دفع",
  "walletLog.typeTokenIncome": "ربح قوة الحوسبة",
  "walletLog.typeTokenLoss": "خسارة قوة الحوسبة",
  "walletLog.typeServerIncome": "عائد الخادم",
  "walletLog.typeTransferReturn": "إرجاع السحب",
  "walletLog.typeFreezeBuy": "تجميد (شراء)",
  "walletLog.typeServerRent": "إيجار الخادم",
  "walletLog.typeUnfreeze": "إلغاء التجميد (انتهاء)",
  "walletLog.typeCompute": "قوة الحوسبة",
  "walletLog.typeRent": "إيجار",
  "walletLog.statusUnknown": "حالة غير معروفة",
  "walletLog.titlePower": "قوة الحوسبة",
  "walletLog.titleRent": "إيجار",
  "walletLog.statusDeposit": "إيداع",
  "walletLog.statusWithdrawal": "سحب",
  "walletLog.statusPay": "دفع",
  "walletLog.statusPowerProfit": "ربح قوة الحوسبة",
  "walletLog.statusPowerLoss": "خسارة قوة الحوسبة",
  "walletLog.statusServerIncome": "عائد الخادم",
  "walletLog.statusWithdrawalReturn": "إرجاع السحب",
  "walletLog.statusPurchaseFreeze": "تجميد (شراء)",
  "walletLog.statusServerRent": "إيجار الخادم",
  "walletLog.statusExpireUnfreeze": "إلغاء التجميد (انتهاء)",

  // ===== مركز الأعضاء - نظرة عامة على الأصول =====
  "memberBox.assetOverview": "نظرة عامة على الأصول",
  "memberBox.realTime": "تحديث فوري",
  "memberBox.totalAssets": "إجمالي الأصول",
  "memberBox.vsYesterday": "مقارنة بالأمس",
  "memberBox.availableBalance": "الرصيد المتاح",
  "memberBox.frozenFunds": "الأموال المجمدة",
  "memberBox.incomeTrend": "اتجاه العوائد",
  "memberBox.hashIncome": "عائد قوة الحوسبة",
  "memberBox.leaseIncome": "عائد الإيجار",
  "memberBox.hashIncomeTotal": "إجمالي عائد قوة الحوسبة",
  "memberBox.leaseIncomeTotal": "إجمالي عائد الإيجار",
  "memberBox.totalIncome": "إجمالي العائد",
  "memberBox.vsLastDay": "مقارنة بالأمس",
  "memberBox.time7d": "7 أيام",
  "memberBox.time15d": "15 يومًا",
  "memberBox.time30d": "30 يومًا",

  // ===== مركز الأعضاء - قائمة المنتجات =====
  "productToken.region": "المنطقة",
  "productToken.allRegion": "جميع المناطق",
  "productToken.status": "الحالة",
  "productToken.allStatus": "جميع الحالات",
  "productToken.statusActive": "قيد التنفيذ",
  "productToken.statusCompleted": "مكتمل",
  "productToken.statusFrozen": "مجمّد",
  "productToken.statusUnknown": "حالة غير معروفة",
  "productToken.reset": "إعادة تعيين",
  "productToken.loading": "جارٍ التحميل...",
  "productToken.empty": "لا توجد منتجات",
  "productToken.quantity": "الكمية",
  "productToken.period": "الفترة",
  "productToken.latestProfit": "أحدث ربح/خسارة",
  "productToken.settledProfit": "الربح/الخسارة المسوية",
  "productToken.periodProfit": "ربح/خسارة الفترة",
  "productToken.totalProfit": "إجمالي الربح/الخسارة",
  "productToken.action": "إجراء",
  "productToken.view": "عرض",
  "productToken.day": "يوم",
  "productToken.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "productToken.firstPage": "الصفحة الأولى",
  "productToken.prevPage": "السابقة",
  "productToken.nextPage": "التالية",
  "productToken.lastPage": "الأخيرة",
  "productToken.perPage": "{count} سجل/صفحة",
  "productToken.detailTitle": "تفاصيل المنتج",
  "productToken.productCode": "رمز المنتج",
  "productToken.orderCode": "رقم الطلب",
  "productToken.orderName": "اسم المنتج",
  "productToken.tradeInfo": "معلومات المعاملة",
  "productToken.tradeTime": "وقت المعاملة",
  "productToken.buyPrice": "سعر الشراء",
  "productToken.principal": "رأس المال",
  "productToken.fee": "الرسوم",
  "productToken.latestPrice": "أحدث سعر",
  "productToken.profitInfo": "معلومات الربح/الخسارة",
  "productToken.estimatedProfit": "إجمالي الربح/الخسارة المتوقع",
  "productToken.remark": "ملاحظة",
  "productToken.close": "إغلاق",

  // ===== مركز الأعضاء - قائمة منتجات الإيجار =====
  "productServer.region": "المنطقة",
  "productServer.allRegion": "جميع المناطق",
  "productServer.status": "الحالة",
  "productServer.allStatus": "جميع الحالات",
  "productServer.statusActive": "قيد التنفيذ",
  "productServer.statusActive2": "قيد التشغيل",
  "productServer.statusCompleted": "مكتمل",
  "productServer.statusFrozen": "مجمّد",
  "productServer.statusUnknown": "حالة غير معروفة",
  "productServer.reset": "إعادة تعيين",
  "productServer.loading": "جارٍ التحميل...",
  "productServer.empty": "لا توجد منتجات",
  "productServer.productName": "اسم المنتج",
  "productServer.share": "الحصة",
  "productServer.countdown": "العد التنازلي",
  "productServer.unsettledIncome": "عائد غير مسوى",
  "productServer.settled": "تمت التسوية",
  "productServer.totalIncome": "إجمالي العائد",
  "productServer.period": "الفترة",
  "productServer.latestProfit": "أحدث ربح/خسارة",
  "productServer.settledProfit": "الربح/الخسارة المسوية",
  "productServer.periodProfit": "ربح/خسارة الفترة",
  "productServer.totalProfit": "إجمالي الربح/الخسارة",
  "productServer.action": "إجراء",
  "productServer.view": "عرض",
  "productServer.day": "يوم",
  "productServer.paginationInfo":
    "إجمالي {total} سجل، الصفحة {page} / {totalPages}",
  "productServer.firstPage": "الصفحة الأولى",
  "productServer.prevPage": "السابقة",
  "productServer.nextPage": "التالية",
  "productServer.lastPage": "الأخيرة",
  "productServer.perPage": "{count} سجل/صفحة",
  "productServer.detailTitle": "تفاصيل المنتج",
  "productServer.productCode": "رمز المنتج",
  "productServer.orderCode": "رقم الطلب",
  "productServer.orderName": "اسم المنتج",
  "productServer.leaseInfo": "معلومات الإيجار",
  "productServer.leaseDate": "تاريخ الإيجار",
  "productServer.rent": "الإيجار",
  "productServer.maintenanceFee": "رسوم الصيانة",
  "productServer.profitInfo": "معلومات العائد",
  "productServer.estimatedLeaseIncome": "إجمالي عائد الإيجار المتوقع",
  "productServer.settledIncome": "العائد المسوى",
  "productServer.phase": "{count} مرحلة",
  "productServer.phaseList": "أرباح المراحل",
  "productServer.currentPhase": "المرحلة الحالية",
  "productServer.remark": "ملاحظة",
  "productServer.close": "إغلاق",

  // ===== صفحة الإيداع =====
  "depositPage.title": "💰 إيداع الحساب",
  "depositPage.desc": "اختر طريقة الإيداع، وصول سريع",
  "depositPage.balance": "الرصيد الحالي",
  "depositPage.methodCrypto": "🪙 العملات الرقمية",
  "depositPage.methodOnline": "💳 إيداع عبر الإنترنت",
  "depositPage.coin": "العملة",
  "depositPage.protocol": "البروتوكول",
  "depositPage.qrAlt": "رمز QR للإيداع",
  "depositPage.qrPlaceholder": "لا يوجد رمز QR",
  "depositPage.copy": "📋 نسخ",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ يدعم فقط تحويل <strong>{coin}</strong> ({protocol})، يرجى عدم إرسال أصول أخرى",
  "depositPage.amountPlaceholder": "أدخل مبلغ الإيداع (اختياري)",
  "depositPage.transferBtn": "🚀 لقد قمت بالتحويل",
  "depositPage.emptyState": "👆 يرجى اختيار العملة والبروتوكول",
  "depositPage.noticeTitle": "📋 ملاحظات الإيداع",
  "depositPage.onlineCardName1": "بطاقة الائتمان/الخصم",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "الدفع ←",
  "depositPage.onlineCardName2": "تحويل بنكي",
  "depositPage.onlineCardDesc2": "الوصول خلال 1-3 أيام عمل",
  "depositPage.onlineCardBtn2": "الحصول على المعلومات ←",
  "depositPage.onlineCardName3": "الدفع عبر طرف ثالث",
  "depositPage.onlineCardDesc3": "Alipay · WeChat · Paypal",
  "depositPage.onlineCardBtn3": "الدفع ←",
  "depositPage.notice1Title": "وقت الوصول",
  "depositPage.notice1Desc":
    "يتطلب إيداع العملات الرقمية انتظار تأكيد شبكة البلوكشين، عادةً 10-30 دقيقة، حسب ازدحام الشبكة.",
  "depositPage.notice2Title": "الحد الأدنى للإيداع",
  "depositPage.notice2Desc":
    "الحد الأدنى للإيداع الواحد هو 0.001 BTC أو ما يعادله بعملات أخرى، ولن يتم إيداع المبالغ الأقل من ذلك.",
  "depositPage.notice3Title": "متطلبات عدد التأكيدات",
  "depositPage.notice3Desc":
    "يتطلب BTC 3 تأكيدات للشبكة، ويتطلب ETH/TRX/USDT 12 تأكيدًا قبل إضافتها إلى رصيد الحساب.",
  "depositPage.notice4Title": "تنبيه أمان الأصول",
  "depositPage.notice4Desc":
    "يرجى التحقق بعناية من عنوان الإيداع ونوع البروتوكول، فقد تؤدي العمليات الخاطئة إلى فقدان الأصول بشكل دائم، ولا تتحمل المنصة المسؤولية.",
  "depositPage.feeInfo": "💸 الرسوم: {fee}",

  // ===== صفحة السحب =====
  "withdraw.title": "💸 سحب الحساب",
  "withdraw.desc": "سحب سريع، وصول آمن",
  "withdraw.balance": "الرصيد المتاح",
  "withdraw.methodCrypto": "🪙 العملات الرقمية",
  "withdraw.methodBank": "🏦 سحب بنكي",
  "withdraw.selectCoin": "اختر العملة",
  "withdraw.selectNetwork": "اختر شبكة السحب",
  "withdraw.address": "عنوان السحب",
  "withdraw.bindAddress": "➕ ربط العنوان",
  "withdraw.selectAddress": "يرجى اختيار عنوان السحب",
  "withdraw.noAddress": "لا يوجد عنوان متاح",
  "withdraw.noAddressTip": "⚠️ لا يوجد عنوان {coin} مرتبط، يرجى أولاً",
  "withdraw.bindLink": "ربط العنوان",
  "withdraw.amount": "مبلغ السحب",
  "withdraw.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "withdraw.emailCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "withdraw.resend": "إعادة المحاولة بعد {count} ثانية",
  "withdraw.sendCode": "إرسال رمز التحقق",
  "withdraw.expectedArrival": "الوصول المتوقع",
  "withdraw.networkFee": "رسوم الشبكة",
  "withdraw.actualArrival": "المبلغ الفعلي المستلم",
  "withdraw.submitting": "⏳ جارٍ التقديم...",
  "withdraw.confirm": "🚀 تأكيد السحب",
  "withdraw.selectFirst": "👆 يرجى اختيار العملة والشبكة",
  "withdraw.minAmount": "الحد الأدنى للسحب",
  "withdraw.maxAmount": "الحد الأقصى للسحب",
  "withdraw.all": "الكل",
  "withdraw.available": "متاح",
  "withdraw.insufficientBalance": "رصيد غير كافٍ",
  "withdraw.enterAmount": "أدخل مبلغ السحب",
  "withdraw.enterCode": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "withdraw.selectAddressFirst": "يرجى اختيار عنوان السحب",
  "withdraw.success": "تم تقديم طلب السحب",
  "withdraw.fail": "فشل السحب",
  "withdraw.arrivalTime": "10-30 دقيقة",
  "withdraw.noticeTitle": "📋 ملاحظات السحب",
  "withdraw.notice1Title": "وقت الوصول",
  "withdraw.notice1Desc":
    "عادةً ما يستغرق سحب العملات الرقمية 10-30 دقيقة للوصول، حسب سرعة تأكيد شبكة البلوكشين.",
  "withdraw.notice2Title": "الحد الأدنى للسحب",
  "withdraw.notice2Desc":
    "الحد الأدنى للسحب الواحد هو 0.001 BTC أو ما يعادله بعملات أخرى، ولن يتم تقديم المبالغ الأقل من ذلك.",
  "withdraw.notice3Title": "التحقق من العنوان",
  "withdraw.notice3Desc":
    "يرجى التحقق بعناية من عنوان السحب، فقد تؤدي العمليات الخاطئة إلى فقدان الأصول بشكل دائم، ولا تتحمل المنصة المسؤولية.",
  "withdraw.notice4Title": "شرح الرسوم",
  "withdraw.notice4Desc":
    "رسوم السحب تحددها شبكة البلوكشين، ولا تفرض المنصة رسومًا إضافية. سيتم خصم الرسوم من مبلغ السحب.",
  "withdraw.codeError": "رمز التحقق خاطئ",
  "withdraw.twoFactorDesc":
    "أدخل رمز التحقق بخطوتين لإرسال رمز التحقق عبر البريد الإلكتروني",
  "withdraw.selectBank": "اختر الحساب البنكي",
  "withdraw.selectBankPlaceholder": "يرجى اختيار الحساب البنكي",
  "withdraw.bankBOC": "بنك الصين",
  "withdraw.bankICBC": "البنك الصناعي والتجاري الصيني",
  "withdraw.addBank": "+ إضافة حساب جديد",
  "withdraw.bankAmount": "مبلغ السحب (USD)",
  "withdraw.exchangeRate": "💱 سعر الصرف",
  "withdraw.arrivalTimeLabel": "⏱️ وقت الوصول",
  "withdraw.bankArrivalTime": "1-3 أيام عمل",
  "withdraw.bankConfirm": "🏦 تأكيد السحب",
  "withdraw.bankSuccess":
    "🏦 تم تقديم طلب السحب البنكي، سيصل خلال 1-3 أيام عمل",

  // ===== صفحة ربط العنوان =====
  "bindAddress.title": "🔗 ربط عنوان المحفظة",
  "bindAddress.desc": "اربط عنوان محفظة العملات الرقمية الخاص بك للسحب",
  "bindAddress.cardTitle": "➕ ربط محفظة جديدة",
  "bindAddress.selectCoin": "اختر العملة",
  "bindAddress.selectProtocol": "اختر البروتوكول",
  "bindAddress.walletAddress": "عنوان المحفظة",
  "bindAddress.walletAddressPlaceholder": "أدخل عنوان محفظتك",
  "bindAddress.emailCode": "رمز التحقق عبر البريد الإلكتروني",
  "bindAddress.emailCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "bindAddress.resend": "إعادة المحاولة بعد {count} ثانية",
  "bindAddress.sendCode": "إرسال رمز التحقق",
  "bindAddress.confirmBind": "🔗 تأكيد الربط",
  "bindAddress.noticeTitle": "📋 تعليمات الربط",
  "bindAddress.twoFactorDesc":
    "أدخل رمز التحقق بخطوتين لإرسال رمز التحقق عبر البريد الإلكتروني",
  "bindAddress.notice1Title": "أمان الأصول",
  "bindAddress.notice1Desc":
    "تأكد من أن عنوان المحفظة الذي تربطه ملكك، وأن المفتاح الخاص محفوظ لديك.",
  "bindAddress.notice2Title": "قيود السحب",
  "bindAddress.notice2Desc":
    "لا يمكن السحب خلال 24 ساعة بعد الربط، لحماية أمان أصول الحساب.",
  "bindAddress.notice3Title": "التحقق عبر البريد الإلكتروني",
  "bindAddress.notice3Desc":
    "يتطلب ربط محفظة جديدة تأكيدًا عبر رمز التحقق البريد الإلكتروني.",
  "bindAddress.notice4Title": "التحقق من العنوان",
  "bindAddress.notice4Desc":
    "يرجى التحقق بعناية من عنوان المحفظة، فقد يؤدي الربط الخاطئ إلى عدم استرجاع الأصول.",
  "bindAddress.msgAddressInvalid": "⚠️ يرجى إدخال عنوان محفظة صحيح أولاً",
  "bindAddress.msgCodeError": "رمز التحقق خاطئ",
  "bindAddress.msgFormInvalid":
    "يرجى ملء جميع المعلومات والحصول على رمز التحقق عبر البريد الإلكتروني",

  // ===== صفحة تسجيل الدخول =====
  "login.title": "سحابة قوة الحوسبة AI",
  "login.subtitle": "AI computing power cloud",
  "login.usernamePlaceholder": "أدخل اسم الحساب",
  "login.passwordPlaceholder": "أدخل كلمة مرور الحساب",
  "login.forgotPassword": "نسيت كلمة المرور",
  "login.loginBtn": "تسجيل الدخول",
  "login.noQualification": "ليس لديك الأهلية بعد؟",
  "login.applyNow": "تقدم بطلب للحصول على الأهلية الآن",
  "login.loginSuccess": "تم تسجيل الدخول بنجاح",
  "login.enterCredentials": "يرجى إدخال اسم الحساب وكلمة المرور",
  "login.loading": "جارٍ التحميل...",

  // ===== صفحة التسجيل/طلب الأهلية =====
  "register.back": "العودة لتسجيل الدخول",
  "register.statusBadge": "طلب الأهلية · مراجعة يدوية",
  "register.title": "طلب الحقوق والأهلية",
  "register.subtitle":
    "بعد تقديم المعلومات، سنكمل المراجعة خلال 24 ساعة ونخطرك عبر البريد الإلكتروني",
  "register.basicInfo": "المعلومات الأساسية",
  "register.firstNamePlaceholder": "أدخل اسمك الأول",
  "register.lastNamePlaceholder": "أدخل اسم عائلتك",
  "register.genderMale": "ذكر",
  "register.genderFemale": "أنثى",
  "register.genderSecret": "خاص",
  "register.birthdayPlaceholder": "اختر تاريخ الميلاد",
  "register.maritalStatus": "الحالة الاجتماعية",
  "register.maritalUnmarried": "أعزب",
  "register.maritalMarried": "متزوج",
  "register.maritalDivorced": "مطلق",
  "register.maritalWidowed": "أرمل",
  "register.contactAddress": "عنوان الاتصال",
  "register.addressPlaceholder": "أدخل عنوان الاتصال",
  "register.occupationInfo": "المعلومات المهنية",
  "register.workUnitPlaceholder": "أدخل جهة العمل",
  "register.workAddressPlaceholder": "أدخل عنوان العمل",
  "register.occupationPlaceholder": "أدخل مهنتك",
  "register.incomePlaceholder": "اختر نطاق الدخل السنوي",
  "register.incomeBelow5": "أقل من 50 ألف",
  "register.income5to10": "50 ألف - 100 ألف",
  "register.income10to20": "100 ألف - 200 ألف",
  "register.income20to50": "200 ألف - 500 ألف",
  "register.income50to100": "500 ألف - مليون",
  "register.incomeAbove100": "أكثر من مليون",
  "register.otherInfo": "معلومات أخرى",
  "register.remarksPlaceholder":
    "ملاحظات إضافية (اختياري، مثل سبب الطلب، احتياجات خاصة...)",
  "register.accountInfo": "معلومات الحساب",
  "register.inviteCodePlaceholder": "أدخل رمز التحقق",
  "register.emailPlaceholder":
    "أدخل عنوان البريد الإلكتروني (سيتم إرسال نتيجة المراجعة إلى هذا البريد)",
  "register.verifyCodePlaceholder": "أدخل رمز التحقق عبر البريد الإلكتروني",
  "register.agreementText":
    "أقر بأن المعلومات المذكورة أعلاه صحيحة وفعالة، وأوافق على",
  "register.agreementLink": "«اتفاقية المستخدم»",
  "register.auditNotice1": "بعد التقديم سنقوم بمراجعة يدوية",
  "register.auditNotice2": "خلال 24 ساعة",
  "register.auditNotice3":
    " سنخطرك عبر البريد الإلكتروني، يرجى التأكد من صحة عنوان البريد الإلكتروني.",
  "register.submitBtn": "تقديم طلب المراجعة",
  "register.submitting": "جارٍ التقديم...",
  "register.hasAccount": "لديك حساب بالفعل؟",
  "register.gotoLogin": "تسجيل الدخول",
  "register.successTitle": "تم التقديم بنجاح!",
  "register.successDesc1": "تم استلام طلب الأهلية الخاص بك، سنقوم",
  "register.successDesc2": "خلال 24 ساعة",
  "register.successDesc3": " بإكمال المراجعة.",
  "register.successDesc4": "سيتم إرسال نتيجة المراجعة إلى البريد الإلكتروني:",
  "register.successTip": "يرجى متابعة بريدك الإلكتروني، شكرًا لطلبك!",
  "register.modalBtn": "فهمت",
  "register.sending": "جارٍ الإرسال",
  "register.resendSuffix": "ثانية لإعادة المحاولة",
  "register.auditNoticeMid": "، سيتم إرسال نتيجة المراجعة خلال",
  "register.invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صحيح",
  "register.codeSent": "تم إرسال رمز التحقق إلى بريدك الإلكتروني، يرجى التحقق",
  "register.inviteCodeInvalid": "يرجى إدخال رمز دعوة من 6 أرقام",
  "register.verifyCodeInvalid": "يرجى إدخال رمز تحقق بريد إلكتروني من 4 أرقام",
  "register.firstNameRequired": "يرجى إدخال اسمك الحقيقي",
  "register.lastNameRequired": "يرجى إدخال اسمك الحقيقي",
  "register.genderRequired": "يرجى اختيار جنسك",
  "register.birthdayRequired": "يرجى اختيار تاريخ ميلادك",
  "register.maritalRequired": "يرجى اختيار حالتك الاجتماعية",
  "register.addressRequired": "يرجى إدخال عنوانك",
  "register.workUnitRequired": "يرجى إدخال جهة عملك",
  "register.workAddressRequired": "يرجى إدخال عنوان عملك",
  "register.occupationRequired": "يرجى إدخال مهنتك",
  "register.incomeRequired": "يرجى اختيار نطاق دخلك السنوي",
  "register.agreeRequired":
    "يرجى قراءة والموافقة على شروط مراجعة الأهلية وسياسة الخصوصية",
  "register.registerFail": "فشل التسجيل",
  "register.submitFail": "فشل التقديم، يرجى المحاولة لاحقًا",

  // ===== صفحة إعادة تعيين كلمة المرور =====
  "reset.back": "العودة لتسجيل الدخول",
  "reset.title": "استعادة كلمة المرور",
  "reset.subtitleStep1": "تحقق من الهوية، أعد تعيين كلمة مرور حسابك",
  "reset.subtitleStep2": "عيّن كلمة مرور جديدة، لضمان أمان الحساب",
  "reset.emailPlaceholder": "أدخل عنوان البريد الإلكتروني المسجل",
  "reset.captchaPlaceholder": "أدخل رمز التحقق",
  "reset.sending": "جارٍ الإرسال",
  "reset.getCaptcha": "الحصول على رمز التحقق",
  "reset.nextStep": "الخطوة التالية",
  "reset.newPasswordPlaceholder": "عيّن كلمة مرور جديدة (6 أرقام على الأقل)",
  "reset.confirmPasswordPlaceholder": "أدخل كلمة المرور الجديدة مرة أخرى",
  "reset.resetBtn": "إعادة التعيين الآن",
  "reset.rememberPassword": "تذكرت كلمة المرور؟",
  "reset.gotoLogin": "تسجيل الدخول",
  "reset.invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صحيح",
  "reset.captchaSent": "تم إرسال رمز التحقق بنجاح",
  "reset.captchaInvalid": "يرجى إدخال رمز تحقق صحيح (4 أرقام على الأقل)",
  "reset.passwordTooShort": "كلمة المرور الجديدة يجب أن تكون 6 أرقام على الأقل",
  "reset.passwordMismatch": "كلمتا المرور غير متطابقتين",
  "reset.resetSuccess":
    "تم إعادة تعيين كلمة المرور بنجاح! يرجى تسجيل الدخول مرة أخرى",

  // ===== صفحة التحقق من الهوية =====
  "verify.statusBadge": "التحقق من الهوية · تعبئة المعلومات",
  "verify.title": "توثيق الحساب",
  "verify.subtitle":
    "يرجى تعبئة معلومات هويتك الحقيقية، سيتم إجراء مراجعة يدوية بعد التقديم",
  "verify.accountSecurity": "أمان الحساب",
  "verify.loginPassword": "كلمة مرور تسجيل الدخول",
  "verify.confirmLoginPassword": "تأكيد كلمة مرور تسجيل الدخول",
  "verify.tradePassword": "كلمة مرور المعاملات",
  "verify.confirmTradePassword": "تأكيد كلمة مرور المعاملات",
  "verify.securityQuestion": "سؤال الأمان",
  "verify.securityAnswer": "إجابة السؤال",
  "verify.basicInfo": "المعلومات الأساسية",
  "verify.country": "الدولة",
  "verify.countryPlaceholder": "اختر الدولة",
  "verify.phone": "رقم الهاتف",
  "verify.realName": "الاسم الحقيقي",
  "verify.idNumber": "رقم الهوية",
  "verify.idPhoto": "صورة الهوية",
  "verify.frontPhoto": "الصورة الأمامية",
  "verify.backPhoto": "الصورة الخلفية",
  "verify.handPhoto": "صورة الهوية باليد",
  "verify.uploading": "جارٍ الرفع...",
  "verify.clickUpload": "انقر للرفع",
  "verify.uploadHint": "يدعم JPG / PNG، يُنصح بأقل من 5MB",
  "verify.uploadHandHint":
    "يرجى التقاط صورة بالهوية في يدك، مع التأكد من وضوح الوجه ومعلومات الهوية",
  "verify.reupload": "إعادة الرفع",
  "verify.auditNotice1": "سيتم إجراء مراجعة يدوية بعد التقديم",
  "verify.auditNoticeMid": "، سيتم إرسال نتيجة المراجعة خلال",
  "verify.auditNotice2": "24 ساعة",
  "verify.auditNotice3": " سيتم إخطارك، يرجى التأكد من صحة المعلومات.",
  "verify.submitBtn": "تقديم التوثيق",
  "verify.submitting": "جارٍ التقديم...",
  "verify.hasAccount": "لديك حساب بالفعل؟",
  "verify.gotoLogin": "تسجيل الدخول",
  "verify.successTitle": "تم التقديم بنجاح!",
  "verify.successDesc1": "تم تقديم معلومات التوثيق الخاصة بك، سنقوم",
  "verify.successDesc2": "خلال 24 ساعة",
  "verify.successDesc3": " بإكمال المراجعة.",
  "verify.successDesc4": "سيتم إخطارك بنتيجة المراجعة عبر رسالة نصية.",
  "verify.successTip": "يرجى إبقاء هاتفك متاحًا، شكرًا لتعاونك!",
  "verify.modalBtn": "فهمت",
  "verify.loginPasswordPlaceholder":
    "عيّن كلمة مرور تسجيل الدخول (6 أرقام على الأقل)",
  "verify.confirmLoginPasswordPlaceholder":
    "أدخل كلمة مرور تسجيل الدخول مرة أخرى",
  "verify.tradePasswordPlaceholder":
    "عيّن كلمة مرور المعاملات (6 أرقام على الأقل)",
  "verify.confirmTradePasswordPlaceholder": "أدخل كلمة مرور المعاملات مرة أخرى",
  "verify.securityQuestionPlaceholder": "أدخل سؤال الأمان",
  "verify.securityAnswerPlaceholder": "أدخل إجابة السؤال",
  "verify.phonePlaceholder": "أدخل رقم الهاتف",
  "verify.realNamePlaceholder": "أدخل الاسم الحقيقي (مطابق للهوية)",
  "verify.idNumberPlaceholder": "أدخل رقم الهوية",
  "verify.uploadImage": "يرجى رفع ملف صورة",
  "verify.imageTooLarge": "حجم الصورة لا يمكن أن يتجاوز 5MB",
  "verify.uploadSuccess": "تم رفع الصورة بنجاح",
  "verify.uploadFail": "فشل رفع الصورة",
  "verify.uploadFailRetry": "فشل رفع الصورة، يرجى المحاولة لاحقًا",
  "verify.passwordTooShort": "كلمة المرور يجب أن تكون 6 أرقام على الأقل",
  "verify.confirmPasswordRequired": "يرجى إدخال كلمة المرور مرة أخرى",
  "verify.passwordMismatch": "كلمتا المرور غير متطابقتين",
  "verify.tradePasswordTooShort":
    "كلمة مرور المعاملات يجب أن تكون 6 أرقام على الأقل",
  "verify.confirmTradePasswordRequired":
    "يرجى إدخال كلمة مرور المعاملات مرة أخرى",
  "verify.tradePasswordMismatch": "كلمتا مرور المعاملات غير متطابقتين",
  "verify.securityQuestionRequired": "يرجى إدخال سؤال الأمان",
  "verify.countryRequired": "يرجى اختيار الدولة",
  "verify.phoneInvalid": "يرجى إدخال رقم هاتف صحيح",
  "verify.realNameRequired": "يرجى إدخال الاسم الحقيقي (حرفان على الأقل)",
  "verify.idNumberInvalid": "يرجى إدخال رقم هوية صحيح",
  "verify.idFrontRequired": "يرجى رفع الصورة الأمامية للهوية",
  "verify.idBackRequired": "يرجى رفع الصورة الخلفية للهوية",
  "verify.idHandRequired": "يرجى رفع صورة الهوية باليد",
  "verify.submitSuccess": "تم التقديم بنجاح",
  "verify.submitFail": "فشل التقديم",
  "verify.submitFailRetry": "فشل التقديم، يرجى المحاولة لاحقًا",

  // ===== صفحة قائمة الإيجار =====
  "rental.title1": "الخوادم",
  "rental.title2": "الإيجار",
  "rental.desc":
    "خوادم عالية الأداء مختارة، استثمر في أصول قوة الحوسبة الشخصية، وادعم تطوير قوة الحوسبة العالمية",
  "rental.statServers": "خوادم قابلة للإيجار",
  "rental.statAvailability": "التوفر",
  "rental.statSupport": "دعم العملاء",
  "rental.searchPlaceholder": "ابحث عن اسم الخادم، طراز GPU...",
  "rental.filterAll": "الكل",
  "rental.filterHot": "🔥 رائج",
  "rental.filterRecommend": "⭐ موصى به",
  "rental.filterNew": "🌟 جديد",
  "rental.sortDefault": "الترتيب الافتراضي",
  "rental.sortRemainingAsc": "المتبقي ↑",
  "rental.sortRemainingDesc": "المتبقي ↓",
  "rental.sortValueAsc": "القيمة الإجمالية ↑",
  "rental.sortValueDesc": "القيمة الإجمالية ↓",
  "rental.sortIncomeAsc": "الدخل اليومي ↑",
  "rental.sortIncomeDesc": "الدخل اليومي ↓",
  "rental.sortStartAsc": "بداية النشاط ↑",
  "rental.sortStartDesc": "بداية النشاط ↓",
  "rental.sortEndAsc": "نهاية النشاط ↑",
  "rental.sortEndDesc": "نهاية النشاط ↓",
  "rental.resultCount": "إجمالي {count} خادم",
  "rental.loading": "جارٍ التحميل...",
  "rental.empty": "لم يتم العثور على خوادم مطابقة",
  "rental.totalValue": "القيمة الإجمالية",
  "rental.country": "الدولة",
  "rental.incomeTrend": "اتجاه العوائد",
  "rental.activityPeriod": "📅 الفترة",
  "rental.remaining": "⏳ المتبقي",
  "rental.days": "يوم",
  "rental.memory": "الذاكرة",
  "rental.storage": "التخزين",
  "rental.bandwidth": "عرض النطاق",
  "rental.status": "الحالة",
  "rental.available": "✅ متاح للإيجار",
  "rental.full": "⏳ ممتلئ",
  "rental.countdown": "حتى البدء",
  "rental.btnFull": "ممتلئ",
  "rental.btnRent": "استأجر الآن",
  "rental.btnWait": "بانتظار البدء",
  "rental.btnEnded": "انتهى",
  "rental.btnRentList": "الإيجار",
  "rental.btnNotStart": "لم يبدأ",
  "rental.NotRent": "غير متاح للإيجار",
  "rental.value": "القيمة",
  "rental.prev": "← السابقة",
  "rental.next": "التالية ←",
  "rental.perPage": "{count} سجل/صفحة",
  "rental.processBadge": "📋 عملية الإيجار",
  "rental.processTitle1": "ثلاث خطوات سهلة",
  "rental.processTitle2": "لاستئجار الخادم",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "اختر الخادم",
  "rental.step1Desc": "تصفح قائمة الخوادم، واختر التكوين المناسب حسب احتياجاتك",
  "rental.step2Icon": "📝",
  "rental.step2Title": "تقديم طلب الإيجار",
  "rental.step2Desc":
    "املأ مدة الإيجار والغرض وغيرها من المعلومات، وقدم للمراجعة",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "النشر والاستخدام",
  "rental.step3Desc":
    "بعد اجتياز المراجعة، يتم النشر فورًا، وابدأ رحلتك في قوة الحوسبة AI",
  "rental.ctaTitle": "لم تجد الخادم المناسب بعد؟",
  "rental.ctaDesc":
    "تواصل معنا للحصول على حلول مخصصة، وسيوصيك فريقنا المحترف بأفضل تكوين",
  "rental.ctaContact": "تواصل مع خدمة العملاء",
  "rental.ctaFaq": "عرض الأسئلة الشائعة",
  "rental.spec1": "الإصدار الأساسي",
  "rental.spec2": "الإصدار الخفيف",
  "rental.spec3": "إصدار الأداء",
  "rental.spec4": "الإصدار الرائد",
  "rental.tagHot": "🔥 رائج",
  "rental.tagRecommend": "⭐ موصى به",
  "rental.tagNew": "🌟 جديد",
  "rental.statusActive": "قيد التنفيذ",
  "rental.statusPending": "لم يبدأ",
  "rental.statusEnded": "انتهى",
  "rental.income": "العائد",
  "rental.progress": "التقدم",
  "rental.countryAlt": "الدولة",
  "rental.monday": "الاثنين",
  "rental.tuesday": "الثلاثاء",
  "rental.wednesday": "الأربعاء",
  "rental.thursday": "الخميس",
  "rental.friday": "الجمعة",
  "rental.saturday": "السبت",
  "rental.sunday": "الأحد",

  // ===== صفحة قوة الحوسبة =====
  "compute.title": "قوة الحوسبة",
  "compute.back": "رجوع",
  "compute.selectRegion": "اختر المنطقة",
  "compute.allRegion": "جميع المناطق",
  "compute.selectPeriod": "اختر الفترة",
  "compute.day": "يوم",
  "compute.periodTime": "مدة الفترة",
  "compute.purchaseQuantity": "كمية الشراء",
  "compute.expectedProfit": "العائد المتوقع",
  "compute.profitTip":
    "العائد المتوقع هو مجرد متوسط تاريخي، يرجى الرجوع إلى بيانات التسوية الفعلية",
  "compute.baseProfit": "العائد الأساسي",
  "compute.settle24h": "تسوية 24 ساعة",
  "compute.periodProfit": "عائد الفترة",
  "compute.settleDue": "تسوية عند الاستحقاق",
  "compute.totalProfit": "إجمالي العائد",
  "compute.fundDetail": "تفاصيل الأموال",
  "compute.purchaseAmount": "مبلغ الشراء",
  "compute.buyFormula": "أحدث سعر × كمية الشراء",
  "compute.fee": "الرسوم",
  "compute.feeFormula": "مبلغ الشراء × {fee}%",
  "compute.total": "الإجمالي",
  "compute.cancel": "إلغاء",
  "compute.confirmBuy": "تأكيد الشراء",
  "compute.tradeConfirm": "تأكيد المعاملة",
  "compute.enterPassword": "أدخل كلمة مرور المعاملات",
  "compute.confirmPay": "تأكيد الدفع",
  "compute.chart7d": "7 أيام",
  "compute.chart15d": "15 يومًا",
  "compute.chart30d": "30 يومًا",
  "compute.price": "السعر",
  "compute.maxValue": "القيمة القصوى",
  "compute.noData": "لا توجد بيانات",
  "compute.fetchFail": "فشل الحصول على البيانات",
  "compute.selectProduct": "يرجى اختيار المنتج أولاً",
  "compute.quantityMin": "كمية الشراء لا يمكن أن تكون أقل من 1",
  "compute.priceError": "السعر الحالي غير طبيعي، يرجى المحاولة لاحقًا",
  "compute.buySuccess": "تم الشراء بنجاح!",
  "compute.tradeFail": "فشلت المعاملة، يرجى المحاولة لاحقًا",
  "compute.passwordError": "كلمة مرور المعاملات خاطئة، يرجى إعادة الإدخال",
  "compute.buyFail": "فشل الشراء، يرجى المحاولة لاحقًا",

  // ===== صفحة تفاصيل الإيجار =====
  "detail.breadcrumbHome": "الرئيسية",
  "detail.breadcrumbRental": "إيجار الخوادم",
  "detail.breadcrumbDetail": "التفاصيل",
  "detail.badgeHot": "🔥 رائج",
  "detail.badgeAvailable": "✅ متاح للإيجار",
  "detail.badgeSold": "⏳ ممتلئ",
  "detail.badgeEnded": "⏳ انتهى",
  "detail.badgePending": "⏳ لم يبدأ",
  "detail.code": "الرمز: ",
  "detail.specTitle": "المواصفات الكاملة",
  "detail.specGpu": "طراز GPU",
  "detail.specVram": "سعة الذاكرة",
  "detail.specStorage": "سعة التخزين",
  "detail.specRam": "الذاكرة",
  "detail.specBandwidth": "عرض النطاق",
  "detail.specValue": "قيمة الخادم",
  "detail.specCountry": "الدولة",
  "detail.specCountryFlag": "علم الدولة",
  "detail.specStatus": "الحالة",
  "detail.statusFull": "⏳ ممتلئ",
  "detail.statusEnded": "⏳ انتهى",
  "detail.statusPending": "⏳ لم يبدأ",
  "detail.statusAvailable": "✅ متاح للإيجار",
  "detail.chartTitle": "اتجاه العوائد",
  "detail.chartRealTime": "فوري",
  "detail.chartHint": "انقر لعرض الصورة الكبيرة",
  "detail.chart7d": "7 أيام",
  "detail.chart15d": "15 يومًا",
  "detail.chart30d": "30 يومًا",
  "detail.statMax": "الأعلى",
  "detail.statAvg": "المتوسط",
  "detail.statMin": "الأدنى",
  "detail.statChange": "التغير",
  "detail.descTitle": "وصف المنتج",
  "detail.regionTitle": "وصف المنطقة",
  "detail.panelTitle": "💎 استأجر الآن",
  "detail.statusDotFull": "● ممتلئ",
  "detail.statusDotEnded": "● انتهى",
  "detail.statusDotPending": "● لم يبدأ",
  "detail.statusDotAvailable": "● متاح للإيجار",
  "detail.activityPeriod": "📅 وقت الدورة",
  "detail.daysLeft": "متبقي",
  "detail.days": "يوم",
  "detail.subscribeShare": "🎚️ حصة الاشتراك",
  "detail.customShare": "حصة مخصصة",
  "detail.remainingShare": "الحصة المتبقية",
  "detail.shareMsg":
    "لا يمكن أن تتجاوز نسبة الاشتراك قيمة الحوسبة المتبقية البالغة {n}%",
  "detail.incomeDetail": "📈 تفاصيل العائد المتوقع",
  "detail.incomeTip":
    "العائد المتوقع هو مجرد قيمة مرجعية، يرجى الرجوع إلى بيانات التسوية الفعلية",
  "detail.estimate": "تقدير",
  "detail.rate": "معدل العائد:",
  "detail.settleDate": "تاريخ التسوية:",
  "detail.moreStages": "هناك {count} مراحل أخرى",
  "detail.hoverExpand": "مرر للعرض",
  "detail.totalIncome": "إجمالي العائد المتوقع",
  "detail.fundDetail": "💰 تفاصيل الأموال",
  "detail.rentalAmount": "مبلغ الإيجار",
  "detail.maintenanceFee": "رسوم الصيانة",
  "detail.feeFormula": "القيمة الإجمالية × {percent}% × {fee}%",
  "detail.tierDiscount": "خصم متدرج",
  "detail.subscribeTip": "(اشتراك {percent}%)",
  "detail.discountDetail": "🎯 تفاصيل الخصم المتدرج",
  "detail.subscribeGte": "اشتراك ≥ {percent}%",
  "detail.currentSubscribe": "الاشتراك الحالي {percent}%، الخصم -${discount}",
  "detail.total": "الإجمالي",
  "detail.btnFull": "⏳ ممتلئ",
  "detail.btnEnded": "⏳ انتهى",
  "detail.btnPending": "⏳ لم يبدأ",
  "detail.btnRent": "🚀 استأجر الآن",
  "detail.btnOutOfStock": "⏳ غير متوفر مؤقتًا",
  "detail.guaranteeSupport": "دعم عملاء 7×24",
  "detail.guaranteeData": "ضمان أمان البيانات",
  "detail.guaranteeSla": "99.9% SLA",
  "detail.recommendBadge": "🔄 قد يعجبك أيضًا",
  "detail.recommendTitle1": "موصى به",
  "detail.recommendTitle2": "الخوادم",
  "detail.recValue": "القيمة",
  "detail.recDetail": "عرض التفاصيل ←",
  "detail.faqBadge": "❓ الأسئلة الشائعة",
  "detail.faqTitle1": "الإيجار",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 مخطط اتجاه العوائد",
  "detail.spec0": "الإصدار الأساسي",
  "detail.spec1": "الإصدار الخفيف",
  "detail.spec2": "إصدار الأداء",
  "detail.spec3": "الإصدار الرائد",
  "detail.spec4": "الرائد الفائق",
  "detail.faq1Q": "هل يتطلب استئجار الخادم وديعة؟",
  "detail.faq1A":
    "للمستخدمين الذين يستأجرون لأول مرة، قد نفرض نسبة معينة من الوديعة. يمكن للعملاء على المدى الطويل الاستفادة من سياسة تخفيض الوديعة. المبلغ المحدد يعتمد على صفحة التسوية.",
  "detail.faq2Q": "كيف يتم تجديد الإيجار بعد انتهاء المدة؟",
  "detail.faq2A":
    "يمكنك تجديد الإيجار في صفحة «إيجاراتي» في لوحة التحكم. يدعم التجديد باليوم والأسبوع والشهر والربع، وسعر التجديد هو نفس سعر الإيجار الحالي.",
  "detail.faq3Q": "ماذا أفعل إذا تعطل الخادم؟",
  "detail.faq3A":
    "نوفر خدمة دعم فني على مدار الساعة 7×24. في حالة حدوث عطل في الأجهزة، سنستجيب خلال ساعتين ونكمل الإصلاح أو الاستبدال خلال 24 ساعة.",
  "detail.faq4Q": "هل يمكن إنهاء الإيجار مبكرًا؟",
  "detail.faq4A":
    "نعم. يتطلب إنهاء الإيجار مبكرًا دفع غرامة قدرها 30% من الفترة المتبقية. يرجى قراءة «اتفاقية خدمة الإيجار» بعناية عند الإيجار.",
  "detail.faq5Q": "كيف يتم ضمان أمان بيانات الخادم المستأجر؟",
  "detail.faq5A":
    "نستخدم تقنية تشفير البيانات على مستوى المؤسسات، ويتم حماية جميع البيانات أثناء النقل والتخزين. بعد انتهاء الإيجار، سيتم مسح بياناتك بالكامل.",
  "detail.unitWan": "عشرة آلاف",
  "detail.msgOutOfStock": "هذا الخادم غير متوفر مؤقتًا",
  "detail.msgSelectShare": "يرجى اختيار حصة الاشتراك",
  "detail.msgRentFail": "فشل الإيجار",
  "detail.msgRentSuccess": "تم الإيجار بنجاح",
  "detail.msgContact": "يرجى الاتصال بخدمة العملاء: 400-888-8888",
  "detail.pwdTitle": "تأكيد الإيجار",
  "detail.pwdLabel": "أدخل كلمة مرور المعاملات",
  "detail.pwdPlaceholder": "أدخل كلمة مرور المعاملات",
  "detail.pwdConfirm": "تأكيد الإيجار",
  "detail.pwdCancel": "إلغاء",
  "detail.rentNow": "💎 استأجر الآن",
  "detail.rentAmount": "مبلغ الإيجار",
  "detail.subscribe": "اشترك",
  "detail.descProduct": "وصف المنتج",
  "detail.descRegion": "معلومات المنطقة",
  "detail.rentNowBtn": "🚀 استأجر الآن",
  "detail.outOfStock": "⏳ نفد المخزون مؤقتاً",
  "detail.stages": "مراحل",
  "detail.discount": "خصم",
  "detail.rentConfirm": "تأكيد الإيجار",
  "detail.enterPassword": "يرجى إدخال كلمة مرور المعاملة",
  "detail.confirmRent": "تأكيد الإيجار",
  "detail.cancel": "إلغاء",
  "detail.rentyunxz": "قيد التشغيل",
  "detail.outOfStockMsg": "هذا الخادم غير متوفر مؤقتاً",
  "detail.selectShareMsg": "يرجى تحديد حصة الاشتراك",
  "detail.rentFail": "فشل الإيجار",
  "detail.rentSuccess": "تم الإيجار بنجاح",
  "detail.contactService": "اتصل بالدعم: 400-888-8888",
  "detail.tenThousand": "K",

  // ===== صفحة معلومات قوة الحوسبة =====
  "info.emptyTitle": "لا توجد خوادم قوة حوسبة حاليًا",
  "info.emptyDesc":
    "ترقبوا، نحن نعمل بجد لإعداد المزيد من موارد قوة الحوسبة عالية الجودة لكم",
  "info.collapse": "طي",
  "info.expand": "توسيع",
  "info.collapseDetail": "طي التفاصيل",
  "info.expandDetail": "توسيع التفاصيل",
  "info.priceTrend": "📈 اتجاه الأسعار",
  "info.docsTitle": "📄 نظرة عامة",
  "info.unit": "الوحدة",
  "info.latestPrice": "أحدث سعر",
  "info.lastPrice": "سعر الأمس",
  "info.increase": "التغير",
  "info.buyNow": "اشترِ الآن",
  "info.buyCompute": "شراء قوة الحوسبة",
  "info.selectPeriod": "اختر الفترة",
  "info.day": "يوم",
  "info.periodTime": "مدة الفترة",
  "info.purchaseQuantity": "كمية الشراء",
  "info.expectedProfit": "العائد المتوقع",
  "info.profitTip":
    "العائد المتوقع هو مجرد متوسط تاريخي، يرجى الرجوع إلى بيانات التسوية الفعلية",
  "info.baseProfit": "العائد الأساسي",
  "info.settle24h": "تسوية 24 ساعة",
  "info.periodProfit": "عائد الفترة",
  "info.settleDue": "تسوية عند الاستحقاق",
  "info.totalProfit": "إجمالي العائد",
  "info.fundDetail": "تفاصيل الأموال",
  "info.purchaseAmount": "مبلغ الشراء",
  "info.buyFormula": "أحدث سعر × كمية الشراء",
  "info.fee": "الرسوم",
  "info.feeFormula": "مبلغ الشراء × {fee}%",
  "info.total": "الإجمالي",
  "info.cancel": "إلغاء",
  "info.confirmBuy": "تأكيد الشراء",
  "info.tradeConfirm": "تأكيد المعاملة",
  "info.enterPassword": "أدخل كلمة مرور المعاملات",
  "info.confirmPay": "تأكيد الدفع",
  "info.chart7d": "7 أيام",
  "info.chart15d": "15 يومًا",
  "info.chart30d": "30 يومًا",
  "info.price": "السعر",
  "info.maxValue": "القيمة القصوى",
  "info.noData": "لا توجد بيانات",
  "info.fetchFail": "فشل الحصول على البيانات",
  "info.selectProduct": "يرجى اختيار المنتج أولاً",
  "info.quantityMin": "كمية الشراء لا يمكن أن تكون أقل من 1",
  "info.priceError": "السعر الحالي غير طبيعي، يرجى المحاولة لاحقًا",
  "info.buySuccess": "تم الشراء بنجاح!",
  "info.tradeFail": "فشلت المعاملة، يرجى المحاولة لاحقًا",
  "info.passwordError": "كلمة مرور المعاملات خاطئة، يرجى إعادة الإدخال",
  "info.buyFail": "فشل الشراء، يرجى المحاولة لاحقًا",

  // ===== صفحة من نحن =====
  "about.tocTitle": "📑 الفهرس",
  "about.toc1": "السيطرة على الذهب الرقمي",
  "about.toc2": "مصفوفة المنتجات الأساسية",
  "about.toc3": "Aetrivol آمن وموثوق",
  "about.toc4": "القيمة الاستثمارية",
  "about.section1Title":
    "السيطرة على الذهب الرقمي: كن «سيد قوة الحوسبة الفائق» في عصر الذكاء",
  "about.section1P1":
    "عندما تدخل النماذج العالمية الكبيرة معركة التريليونات من المعلمات وينفجر الذكاء المادي بالكامل، حلت قوة الحوسبة محل النفط تمامًا وأصبحت العملة الصعبة النهائية التي تهيمن على ثروة العالم. عمالقة التكنولوجيا يشترون وحدات GPU بجنون دون النظر إلى التكلفة، وتكلفة مراكز الذكاء الحاسوبي التي تصل إلى مئات الملايين تستبعد المستثمرين العاديين. ولدت Aetrivol في الوقت المناسب. من خلال آلية تثبيت قيمة الحوسبة المبتكرة ونموذج إيجار خوادم قوة الحوسبة، نكسر احتكار الأصول ونمكنك من الاستمتاع مباشرة بأعظم وليمة تراكم ثروة في تاريخ البشرية بأبسط وأكثر الطرق مرونة.",
  "about.section2Title": "مصفوفة المنتجات الأساسية: محرك ثروة مزدوج الدفع",
  "about.section2H1":
    "المنتج المبتكر الأول: 【قيمة الحوسبة (Compute Value / CV)】—— «أرباح الترميز» لأصول قوة الحوسبة العالمية",
  "about.section2P1":
    "· كسر الحواجز، أصول مصغرة: نقوم بتقسيم قوة الحوسبة الكلية لمراكز الذكاء الحاسوبي العالمية وخوادم GPU عالية الأداء (NVIDIA Blackwell وHuawei Ascend وغيرها) بشكل موحد. نقطة واحدة من 【قيمة الحوسبة】 تمثل ملكيتك لحصة محددة من قوة الحوسبة في شبكة الحوسبة الذكية العالمية.",
  "about.section2P2":
    "· اشترِ GPU مثل شراء صندوق استثمار: بأقل مبلغ صغير يمكنك الاشتراك في 【قيمة الحوسبة】، لكسر حاجز «صعوبة الحصول على بطاقة». قيمة الحوسبة التي تمتلكها تعمل على المنصة على مدار الساعة، وتستقبل يوميًا أرباح التدفق النقدي الرقمي الناتجة عن استدعاءات النماذج الكبيرة العالمية للذكاء الاصطناعي والوكلاء الذكيين (Agent).",
  "about.section2P3":
    "· سيولة عالية، تحويل نقدي في أي وقت: تتمتع قيمة الحوسبة بسيولة أصول قوية جدًا. مع الزيادة الهائلة في الطلب العالمي على قوة الحوسبة، تتمتع قيمة الحوسبة نفسها بمساحة علاوة عالية جدًا، ويمكنك التداول والتحويل النقدي في أي وقت على المنصة.",
  "about.section2H2":
    "الأعمال الأساسية الثانية: 【إيجار خوادم قوة الحوسبة (Server Leasing)】—— نموذج «المؤجر الرقمي» المستقر طويل الأجل",
  "about.section2P4":
    "· اشتراك الأصول المادية، ملكية خادم حصرية: يمكن للمستثمرين الاشتراك مباشرة في خوادم قوة الحوسبة الكاملة أو رفوف الخوادم القياسية التابعة للمنصة. كل خادم يتم تعيينه بشكل حقيقي على السلسلة وله رقم SN مادي فريد.",
  "about.section2P5":
    "· إيجار طويل الأجل، دخل إيجار مرتفع مستقر: بعد الاشتراك، يتم استضافة الخادم مباشرة في مراكز الذكاء الحاسوبي الفاخرة التابعة للمنصة في مراكز قوة الحوسبة الخضراء العالمية (مثل عقدة الحوسبة الغربية في الصين، شمال أوروبا، الشرق الأوسط وغيرها). تقوم المنصة بتأجير الخادم بدقة لمطوري النماذج الكبيرة الذين يحتاجون بشدة إلى قوة الحوسبة، أو المعاهد البحثية الجامعية، أو شركات الذكاء الاصطناعي المتخصصة، لتأمين عوائد إيجار عالية ومستقرة لمدة 3 إلى 5 سنوات.",
  "about.section3Title": "لماذا تستطيع Aetrivol تحويل المخاطر إلى يقين مطلق؟",
  "about.section3P1":
    "· تثبيت 100% للأصول المادية على السلسلة: نرفض القلاع في الهواء. سواء كانت قيمة الحوسبة التي تمتلكها أو الخادم الذي تستأجره، يتم تعيينها في الوقت الفعلي على السلسلة إلى أجهزة تسريع مادية حقيقية تعمل وتصدر ضوضاء عالية، الأصول مرئية وملموسة وقابلة للتحقق.",
  "about.section3P2":
    "· كفاءة طاقة فائقة و«مقاومة الجغرافيا السياسية» مزدوجة التأمين: مراكز البيانات المعبأة لدينا مجهزة بنسبة 100% بـ«الطاقة النووية المصغرة (SMR) / الطاقة الشمسية المباشرة» أو تقع في ولايات قضائية قانونية غير نزاعية آمنة تمامًا، لتجنب مخاطر موجات تسونامي الشبكة المحلية العالمية وتقلبات الجغرافيا السياسية تمامًا.",
  "about.section3P3":
    "· تأييد العمالقة وضمان طويل الأجل: تختار المنصة أولاً المواقع الناضجة التي تم حجزها مسبقًا للإيجار من قبل عمالقة النماذج الكبيرة مثل Microsoft وOpenAI وDeepSeek، باستخدام ائتمان عمالقة التكنولوجيا كتأييد لعوائدك.",
  "about.section4Title":
    "في الماضي استثمروا في الأراضي والنفط؛ اليوم، نستثمر في قوة الحوسبة.",
  "about.section4P1":
    "عندما تهاجر ذكاء وأعمال البشرية جمعاء إلى العالم الرقمي، فإن قوة الحوسبة هي مادة البناء الوحيدة لهذا العالم الجديد. انضم إلى Aetrivol، واشترِ قيمة الحوسبة الخاصة بك، وابدأ رحلتك في إيجار خوادم قوة الحوسبة. حوّل رأس مالك إلى ذرات قوة حوسبة تعيد تشكيل العالم، وشارك في هذا الانفجار الذكي للثروة!",

  // ===== صفحة الخطأ =====
  "error.backHome": "العودة إلى الصفحة الرئيسية",
  "error.refresh": "تحديث وإعادة المحاولة",
  "error.footerTip": "إذا استمرت المشكلة، يرجى الاتصال بالدعم الفني",
  "error.title404": "الصفحة غير موجودة",
  "error.desc404": "الصفحة التي تبحث عنها غير موجودة أو تمت إزالتها",

  phase: "المرحلة",

  // ar-ae 阿拉伯语
  country: {
    1: "الولايات المتحدة",
    2: "الصين",
    3: "اليابان",
    4: "كوريا الجنوبية",
    5: "ألمانيا",
    6: "المملكة المتحدة",
    7: "فرنسا",
    8: "الإمارات العربية المتحدة",
    9: "سنغافورة",
    10: "إسرائيل",
    11: "روسيا",
    12: "الهند",
    13: "البرازيل",
    14: "إيطاليا",
    15: "إسبانيا",
    16: "البرتغال",
    17: "هولندا",
    18: "بلجيكا",
    19: "سويسرا",
    20: "السويد",
    21: "النرويج",
    22: "فنلندا",
    23: "الدنمارك",
    24: "آيسلندا",
    25: "أيرلندا",
    26: "النمسا",
    27: "بولندا",
    28: "التشيك",
    29: "المجر",
    30: "اليونان",
    31: "أوكرانيا",
    32: "بيلاروسيا",
    33: "رومانيا",
    34: "بلغاريا",
    35: "صربيا",
    36: "كرواتيا",
    37: "ألبانيا",
    38: "إستونيا",
    39: "لاتفيا",
    40: "ليتوانيا",
    41: "مولدوفا",
    42: "سلوفاكيا",
    43: "سلوفينيا",
    44: "البوسنة والهرسك",
    45: "الجبل الأسود",
    46: "مقدونيا الشمالية",
    47: "لوكسمبورغ",
    48: "مالطا",
    49: "أندورا",
    50: "موناكو",
    51: "ليختنشتاين",
    52: "سان مارينو",
    53: "الفاتيكان",
    54: "كندا",
    55: "المكسيك",
    56: "كوبا",
    57: "غواتيمالا",
    58: "هندوراس",
    59: "نيكاراغوا",
    60: "كوستاريكا",
    61: "بنما",
    62: "جامايكا",
    63: "هايتي",
    64: "جمهورية الدومينيكان",
    65: "ترينيداد وتوباغو",
    66: "دومينيكا",
    67: "سانت لوسيا",
    68: "سانت فينسنت والغرينادين",
    69: "غرينادا",
    70: "سانت كيتس ونيفيس",
    71: "أنتيغوا وبربودا",
    72: "باهاماس",
    73: "بربادوس",
    74: "بليز",
    75: "السلفادور",
    76: "الأرجنتين",
    77: "كولومبيا",
    78: "فنزويلا",
    79: "بيرو",
    80: "تشيلي",
    81: "الإكوادور",
    82: "بوليفيا",
    83: "باراغواي",
    84: "الأوروغواي",
    85: "غيانا",
    86: "سورينام",
    87: "أستراليا",
    88: "نيوزيلندا",
    89: "بابوا غينيا الجديدة",
    90: "فيجي",
    91: "جزر سليمان",
    92: "فانواتو",
    93: "ساموا",
    94: "كيريباتي",
    95: "ولايات ميكرونيسيا المتحدة",
    96: "جزر مارشال",
    97: "بالاو",
    98: "ناورو",
    99: "توفالو",
    100: "تونغا",
    101: "جزر كوك",
    102: "نيوي",
    103: "مصر",
    104: "جنوب أفريقيا",
    105: "نيجيريا",
    106: "إثيوبيا",
    107: "كينيا",
    108: "تنزانيا",
    109: "الجزائر",
    110: "المغرب",
    111: "السودان",
    112: "جنوب السودان",
    113: "غانا",
    114: "أنغولا",
    115: "موزمبيق",
    116: "مدغشقر",
    117: "الكاميرون",
    118: "ساحل العاج",
    119: "النيجر",
    120: "بوركينا فاسو",
    121: "مالي",
    122: "السنغال",
    123: "أوغندا",
    124: "زامبيا",
    125: "زيمبابوي",
    126: "تشاد",
    127: "الكونغو",
    128: "جمهورية الكونغو الديمقراطية",
    129: "الغابون",
    130: "بوتسوانا",
    131: "ناميبيا",
    132: "موريشيوس",
    133: "رواندا",
    134: "الصومال",
    135: "جيبوتي",
    136: "إريتريا",
    137: "ليبيا",
    138: "تونس",
    139: "سيراليون",
    140: "ليبيريا",
    141: "توغو",
    142: "بنين",
    143: "غينيا",
    144: "غينيا بيساو",
    145: "غامبيا",
    146: "الرأس الأخضر",
    147: "ساو تومي وبرينسيب",
    148: "غينيا الاستوائية",
    149: "موريتانيا",
    150: "إسواتيني",
    151: "ليسوتو",
    152: "مالاوي",
    153: "جمهورية أفريقيا الوسطى",
    154: "بوروندي",
    155: "جزر القمر",
    156: "سيشيل",
    157: "تركيا",
    158: "إيران",
    159: "العراق",
    160: "المملكة العربية السعودية",
    161: "منغوليا",
    162: "كوريا الشمالية",
    163: "إندونيسيا",
    164: "الفلبين",
    165: "فيتنام",
    166: "تايلاند",
    167: "ماليزيا",
    168: "ميانمار",
    169: "كمبوديا",
    170: "لاوس",
    171: "بروناي",
    172: "تيمور الشرقية",
    173: "باكستان",
    174: "بنغلاديش",
    175: "نيبال",
    176: "بوتان",
    177: "سريلانكا",
    178: "جزر المالديف",
    179: "كازاخستان",
    180: "أوزبكستان",
    181: "تركمانستان",
    182: "قيرغيزستان",
    183: "طاجيكستان",
    184: "أفغانستان",
    185: "سوريا",
    186: "الأردن",
    187: "لبنان",
    188: "فلسطين",
    189: "عمان",
    190: "اليمن",
    191: "الكويت",
    192: "قطر",
    193: "البحرين",
    194: "جورجيا",
    195: "أرمينيا",
    196: "أذربيجان",
    197: "قبرص",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: usContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: usContent.t2,
      },
      t3: {
        title: "التحديات",
        content: usContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: cnContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: cnContent.t2,
      },
      t3: {
        title: "التحديات",
        content: cnContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: jpContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: jpContent.t2,
      },
      t3: {
        title: "التحديات",
        content: jpContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: koContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: koContent.t2,
      },
      t3: {
        title: "التحديات",
        content: koContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: geContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: geContent.t2,
      },
      t3: {
        title: "التحديات",
        content: geContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: ukContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: ukContent.t2,
      },
      t3: {
        title: "التحديات",
        content: ukContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: ukContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: uaeContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: uaeContent.t2,
      },
      t3: {
        title: "التحديات",
        content: uaeContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: uaeContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: frContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: frContent.t2,
      },
      t3: {
        title: "التحديات",
        content: frContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: frContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "الوضع الحالي",
        content: sgContent.t1,
      },
      t2: {
        title: "المزايا الأساسية",
        content: sgContent.t2,
      },
      t3: {
        title: "التحديات",
        content: sgContent.t3,
      },
      t4: {
        title: "الاتجاهات المستقبلية",
        content: sgContent.t4,
      },
    },
  },

  agreement: agreementContent,

  "withdraw.insufficientHandlingFee": "رسوم المعالجة غير كافية",
  "withdraw.twoFactor":
    "لم تقم بتفعيل التحقق بخطوتين، لا يمكنك السحب. يرجى تفعيل التحقق بخطوتين أولاً.",
  "bindAddress.twoFactor":
    "لم تقم بتفعيل التحقق بخطوتين، لا يمكنك ربط العنوان. يرجى تفعيل التحقق بخطوتين أولاً.",
  "productServer.statusPending": "قيد التشغيل",
  "historyToken.add": "إيداع",
  "serverServer.serverover": "تاريخ التسوية",

  "walletLog.statusPeriodIncome": "الدخل الدوري",
  "productToken.statusOver": "انتهى",
  "productServer.phaseDate": "تاريخ التسوية",

  // ===== 认证审核通过页（Approved） =====
  "approved.back": "رجوع",
  "approved.title": "تمت الموافقة على الطلب",
  "approved.subtitle": "تهانينا! تمت الموافقة على مستندات التحقق الخاصة بك.",
  "approved.benefitsTitle": "🎉 يمكنك الآن الاستفادة من المزايا التالية",
  "approved.benefit1": "وصول كامل إلى جميع الوظائف",
  "approved.benefit2": "وصول مبكر إلى الميزات الجديدة",
  "approved.benefit3": "دعم عملاء مخصص",
  "approved.benefit4": "مزيد من الصلاحيات",
  "approved.login": "تسجيل الدخول إلى حسابك",

  // ===== 认证审核中页（Review） =====
  "review.back": "رجوع",
  "review.title": "قيد المراجعة",
  "review.subtitle": "مستندات التحقق الخاصة بك قيد المراجعة. يرجى الانتظار.",
  "review.step1": "إرسال المستندات",
  "review.step2": "قيد المراجعة",
  "review.step3": "مكتمل",
  "review.estimatePrefix": "وقت المراجعة المتوقع: ",
  "review.estimateDefault": "خلال 24 ساعة",
  "review.notifyByEmail": "سيتم إرسال نتيجة المراجعة إلى بريدك الإلكتروني",
  "review.keepContact": "يرجى إبقاء هاتفك متاحاً لاستلام الإشعارات",

  "productToken.timeover": "وقت الانتهاء",

  // ===== About page (v2) =====
  "aboutPage.tocTitle": "📑 الفهرس",
  "aboutPage.toc1": "من نحن",
  "aboutPage.toc2": "الفريق الأساسي",
  "aboutPage.toc3": "العناوين العالمية",
  "aboutPage.s1Title": "من نحن",
  "aboutPage.s1P1": "Aetrivol منصة أساسية لقوة الحوسبة موجهة للاقتصاد الرقمي العالمي، ومتخصصة بعمق في البنية التحتية للذكاء الاصطناعي. وفي ظل الطفرة الهائلة للذكاء الاصطناعي التوليدي والتعلّم العميق، نجحت Aetrivol في إغلاق الحلقة بين تحويل قوة الحوسبة إلى أصول وتأجير الخوادم التجارية، بفضل انتشار عالمي متقدم لمراكز البيانات وأساس تقني قوي. وبصفتها إحدى المنصات القليلة القادرة على تمكين البحث العلمي والتطبيق التجاري لأفضل نماذج الذكاء الاصطناعي في العالم مباشرة، تجاوز متوسط حجم التداول اليومي لمنصة Aetrivol مليار دولار أمريكي. وهذا لا يعكس سيولة وثقة سوقية لا مثيل لهما فحسب، بل يرسّخ أيضًا موقعها الرائد كمركز عالمي لتوزيع قوة الحوسبة.",
  "aboutPage.s1P2": "اليوم تبلغ تكلفة مركز بيانات ذكاء اصطناعي متقدم مئات الملايين، كما أن اختلال العرض والطلب في خوادم GPU شديد جدًا.",
  "aboutPage.s1L1": "حاجز رأس المال: لا يستطيع المستثمرون الأفراد المشاركة مباشرة في تجميع شراء الأجهزة من السوق الأولية.",
  "aboutPage.s1L2": "محفّز الطلب: تنمو استدعاءات النماذج الكبيرة ووكلاء الذكاء الاصطناعي بوتيرة أسية.",
  "aboutPage.s1L3": "منطق العقار: تُظهر موارد الحوسبة المتقدمة خصائص دخل إيجاري تشبه «عقارًا في موقع مركزي».",
  "aboutPage.s1P3": "في مواجهة هذا الاحتكار لقوة الحوسبة، يعيد الحل الذي تقدمه Aetrivol بناء الميزانيات العمومية للمستثمرين حول العالم. وتكمن قيمته الجوهرية في تحويل «التقنية المتقدمة بعيدة المنال» إلى «أصول سائلة سهلة التوزيع».",
  "aboutPage.s1Stat1Label": "متوسط حجم التداول اليومي",
  "aboutPage.s1Stat1Value": "مليار دولار+",
  "aboutPage.s1Stat2Label": "فئة مركز البيانات",
  "aboutPage.s1Stat2Value": "Tier 4",
  "aboutPage.s1Stat3Label": "نسبة التوافر (SLA)",
  "aboutPage.s1Stat3Value": "99.99%",
  "aboutPage.s1H2a": "مصفوفة الأعمال الأساسية: محرّكان لنمو القيمة",
  "aboutPage.s1H3a": "1. الاستثمار في قيمة الحوسبة (Computing Power Tokenization)",
  "aboutPage.s1P4": "تحوّل Aetrivol قوة الحوسبة المادية ذات العتبة المرتفعة إلى أصول «قيمة الحوسبة» قابلة للقياس والتجزئة وبالغة السيولة.",
  "aboutPage.s1L4": "إمكانية الوصول إلى الأصول: لا يتحمل المستثمرون تشغيل الخوادم أو إهلاكها أو تكاليف الكهرباء المرتفعة؛ فبتوزيع قيمة الحوسبة يرتبطون مباشرة بالنمو الجوهري لصناعة الذكاء الاصطناعي العالمية.",
  "aboutPage.s1L5": "عوائد مركّبة ذكية: ترتبط عوائد قيمة الحوسبة ارتباطًا وثيقًا بكفاءة التشغيل الفعلية للخوادم الأساسية وبحركة العرض والطلب، وتضمن خوارزمية التسعير الديناميكية المطوّرة داخليًا عوائد مستقرة وفي الوقت نفسه ذات زخم قوي.",
  "aboutPage.s1H3b": "2. تأجير الخوادم عالية الأداء (Enterprise Server Leasing)",
  "aboutPage.s1P5": "تدير Aetrivol مراكز بيانات خضراء من الفئة Tier 4 في أنحاء العالم، وتقدم خدمات تأجير وحدات GPU صناعية (مثل NVIDIA H100 وسلسلة B200) وعناقيد شرائح ASIC المخصصة.",
  "aboutPage.s1L6": "نشر فوري وتوسّع مرن: جدولة لقوة الحوسبة باستجابة بمستوى الميكروثانية للعملاء المؤسسيين، تدعم من التطوير على جهاز واحد حتى التدريب المتوازي على عناقيد تضم 10,000 وحدة.",
  "aboutPage.s1L7": "مواقع ناضجة بدعم عمالقة التقنية: اجتازت جميع مواقع Aetrivol الأساسية اختبارات ضغط صناعية بالغة الصرامة. واليوم، تم حجز وتأجير عدد كبير من المواقع الناضجة مسبقًا ولفترات طويلة من قِبل عمالقة النماذج الكبرى مثل Microsoft وOpenAI وDeepSeek. ولا يقتصر أثرهم على خلق تدفق نقدي مستقر وطويل الأجل، بل يشكّل الضمانة القصوى لاستقرار المنصة تقنيًا والتزامها.",
  "aboutPage.s1H2b": "المزايا التنافسية الفريدة: الندرة والدرع الأمني",
  "aboutPage.s1L8": "علاوة اليقين التي يثبّتها العمالقة: لأن قادة القطاع مثل Microsoft وOpenAI وDeepSeek يؤجّرون قوة الحوسبة الأساسية لـ Aetrivol بعقود طويلة، تتمتع الأصول الأساسية بمرونة عالية أمام المخاطر وبمعدل خمول شبه معدوم، ما يشكّل حاجزًا طبيعيًا للقيمة.",
  "aboutPage.s1L9": "أمن بمستوى عسكري وتشغيل من الطراز الأول: تضمن تقنية العزل الافتراضي لقوة الحوسبة المطوّرة داخليًا ونظام الفحص الآلي على مدار الساعة أمن البيانات والمهام الحاسوبية بشكل مطلق، مع نسبة توافر (SLA) تبلغ 99.99%.",
  "aboutPage.s1L10": "سيولة استثنائية: حجم تداول يومي يصل إلى مليار دولار أمريكي يضمن سرعة قصوى في تداول أصول الحوسبة وتحويلها إلى نقد داخل المنصة ومنظومتها.",
  "aboutPage.s1H2c": "الخاتمة: مع روّاد العصر",
  "aboutPage.s1P6": "نهاية الذكاء الاصطناعي هي قوة الحوسبة. وبالتمسك بنبض العصر، ومن خلال التكامل الاحتكاري لموارد الحوسبة النادرة ونموذج مبتكر لتحويل الأصول، أصبحت Aetrivol الخيار المشترك لعمالقة التقنية ورؤوس الأموال الكبرى. وهنا لا تستثمر في خوادم فحسب، بل في تذكرة دخول إلى العصر الذهبي للذكاء الاصطناعي.",
  "aboutPage.s2Title": "الفريق الأساسي",
  "aboutPage.s2Group1": "الأعضاء الأساسيون في مجلس الإدارة",
  "aboutPage.s2Group2": "الرئيس التنفيذي (CEO)",
  "aboutPage.s2Group3": "المدير التنفيذي للتقنية (CTO)",
  "aboutPage.s2Group4": "العالم الرئيسي (Chief Scientist)",
  "aboutPage.s2Group5": "رؤساء الأقسام",
  "aboutPage.s2BioLabel": "أبرز المحطات المهنية: ",
  "aboutPage.s2Role1": "رئيس مجلس الإدارة ورئيس لجنة الأمن والأخلاقيات",
  "aboutPage.s2Bio1": "شريك مؤسس والرئيس التنفيذي لـ OpenAI. رئيس Y Combinator سابقًا.",
  "aboutPage.s2Role2": "عضو مجلس الإدارة للتطوير الاستراتيجي وتعاون المنظومات",
  "aboutPage.s2Bio2": "رئيس مجلس الإدارة والرئيس التنفيذي لشركة Microsoft، ويُعدّ الأكثر قدرة في إدارة الاستراتيجية المؤسسية وبناء التحالفات والحوكمة العابرة للحدود.",
  "aboutPage.s2Role3": "مستشار علمي وعضو مجلس إدارة مستقل غير تنفيذي",
  "aboutPage.s2Bio3": "أستاذ فخري في جامعة تورونتو، حائز على جائزة نوبل في الفيزياء لعام 2024 وجائزة تورينغ، ويُلقّب بـ«عرّاب التعلّم العميق».",
  "aboutPage.s2Bio4": "مؤسس Google DeepMind، حائز على جائزة نوبل في الكيمياء لعام 2024.",
  "aboutPage.s2Bio5": "شغلت منصب CTO في OpenAI لفترة طويلة، وكانت من العناصر الأساسية في تطوير Tesla Model X، وأشرفت في OpenAI على التنفيذ الهندسي المعقّد لـ ChatGPT وDALL·E وGPT-4o.",
  "aboutPage.s2Bio6": "شريك مؤسس لـ Safe Superintelligence (SSI)، والشريك المؤسس والعالم الرئيسي السابق في OpenAI.",
  "aboutPage.s2Role7": "نائب رئيس وحدة البنية التحتية لقوة الحوسبة",
  "aboutPage.s2Bio7": "المدير التنفيذي للتصميم سابقًا في Apple. صمّم iPhone وiMac وiPad ويحظى بشهرة عالمية في مجال التصميم.",
  "aboutPage.s2Role8": "مدير الذكاء الاصطناعي المتقدّم ومنظومة المصادر المفتوحة",
  "aboutPage.s2Bio8": "العالم الرئيسي للذكاء الاصطناعي في Meta، حائز على جائزة تورينغ.",
  "aboutPage.s2Role9": "المدير التنفيذي للمنتجات الاستهلاكية والمنظومة (CPO)",
  "aboutPage.s2Bio9": "الرئيس التنفيذي لـ Microsoft AI. شريك مؤسس لـ DeepMind ومؤسس Inflection AI.",
  "aboutPage.s3Title": "العناوين العالمية",
  "aboutPage.s3MapTitle": "شبكة المكاتب العالمية",
  "aboutPage.s3MapHint": "مرّر مؤشر الفأرة فوق علامة الموقع على الخريطة لعرض عنوان المكتب — انقر لتثبيت العرض",
  "aboutPage.s3Country1": "الولايات المتحدة",
  "aboutPage.s3Addr1": "12015 Waterfront Dr, Los Angeles, CA 90094",
  "aboutPage.s3Country2": "سنغافورة",
  "aboutPage.s3Addr2": "438B Alexandra Rd, Alexandra Technopark, Singapore 119968",
  "aboutPage.s3Country3": "قطر",
  "aboutPage.s3Addr3": "Innovation Centre, Al Luqta St, Education City, Doha, Qatar",
  "aboutPage.s3Country4": "فرنسا",
  "aboutPage.s3Addr4": "5 Parvis Alan Turing, 75013 Paris, France",

  // Activity
  "activity.passwordTitle": "كلمة مرور الحجز المسبق",
  "activity.passwordTip": "هذا الحجز المسبق محمي بكلمة مرور. أدخل كلمة مرور النشاط للمتابعة.",
  "activity.passwordPlaceholder": "أدخل كلمة مرور النشاط المكونة من 10 أحرف",
  "activity.passwordRequired": "يرجى إدخال كلمة مرور النشاط",
  "activity.passwordError": "كلمة مرور النشاط غير صحيحة",
  "activity.cancel": "إلغاء",
  "activity.confirm": "تأكيد",
  "activity.preorderTitle": "الحجز المسبق لاستئجار الخادم",
  "activity.discountTitle": "خصومات حسب المبلغ",
  "activity.discountRule": "أنفق ${amount} واحصل على خصم {percent}%",
  "activity.discountHit": "تم التطبيق",
  "activity.selectShare": "اختر الحصة",
  "activity.remainingShare": "الحصة المتبقية",
  "activity.originAmount": "المبلغ الأصلي",
  "activity.discountAmount": "مبلغ الخصم",
  "activity.serviceFee": "رسوم الخدمة",
  "activity.payTotal": "إجمالي المبلغ المستحق",
  "activity.payNow": "ادفع الآن",
  "activity.tradeTitle": "تأكيد الدفع",
  "activity.tradeLabel": "أدخل كلمة مرور التداول",
  "activity.loadFail": "فشل تحميل النشاط",
  "activity.cannotBuy": "لم يعد هذا الحجز المسبق متاحًا",
  "activity.minShare": "الحد الأدنى للحصة هو {percent}%",
  "activity.payFail": "فشل الدفع، يرجى المحاولة مرة أخرى",
  "activity.paySuccess": "تم الحجز المسبق بنجاح",
  "activity.tokenTitle": "نشاط قوة الحوسبة",
  "activity.ongoing": "جارٍ",
  "activity.completed": "مكتمل",
  "activity.rewardCountry": "الدولة",
  "activity.rewardPeriod": "الفترة",
  "activity.days": "أيام",
  "activity.rewardPercent": "الحصة",
  "activity.rewardTime": "وقت التوزيع",
  "activity.rewardUsers": "المستخدمون",
  "activity.rewardShares": "الحصص الصادرة",
  "activity.tokenDesc1": "عند التسوية، نجمع جميع حصص قوة الحوسبة التي تمتلكها في جميع الفترات في {country}، ونكافئك بحصة {percent}% من هذا الإجمالي كحصص جديدة.",
  "activity.tokenDesc2": "تُصدر المكافآت تلقائيًا في {time} في منتج الفترة المحددة البالغة {period} يومًا، وتبدأ في تحقيق الدخل فورًا.",
  "activity.tokenDesc3": "حصص المكافأة مجانية من رسوم رأس المال؛ ويتم تسوية الدخل وفقًا للقواعد العادية للمنتج.",
  "activity.gotIt": "فهمت",
};
